// TR
export const locale = {
    "seoExtra": {
        "ogImage": "Sosyal Paylaşım Görseli (URL)",
        "ogImageHint": "Sosyal medyada paylaşımda görünen görsel. Boşsa varsayılan/otomatik görsel kullanılır.",
        "canonical": "Canonical URL",
        "canonicalHint": "Bu sayfanın asıl (kanonik) adresi. Boşsa sayfanın kendi adresi kullanılır.",
        "noIndex": "Arama motorlarında gizle (noindex)",
        "hideSitemap": "Site haritasından çıkar",
        "advanced": "Gelişmiş SEO"
    },
    "extra": {
        "customerGroups": "Müşteri Grupları",
        "b2bStatus": "B2B Durumu",
        "b2bNone": "B2B değil",
        "b2bApproved": "Hesabı Var",
        "b2bPending": "Onay Bekliyor",
        "b2bRejected": "Reddedildi",
        "skuBarcodeWeight": "SKU / Barkod / Ağırlık",
        "weightG": "Ağırlık (g)",
        "langNameExample": "Türkçe",
        "currencyNameExample": "Türk Lirası",
        "appSearch": "Uygulama ara (kargo, ödeme, trendyol...)",
        "yourStore": "MAĞAZANIZ"
    },
    "common": {
        "comingSoon": {
            "badge": "Çok Yakında",
            "heading": "Bu modül çok yakında burada!",
            "description": "Bu özellik üzerinde çalışıyoruz ve yakında kullanımınıza sunulacak. İlginiz için teşekkür ederiz."
        },
        "accessDenied": {
            "title": "Bu alana erişiminiz yok",
            "description": "Bu sayfayı görüntülemek için gerekli yetkiye sahip değilsiniz. Erişim gerekiyorsa lütfen sistem yöneticinizle iletişime geçin.",
            "goBack": "Geri Dön",
            "goDashboard": "Panele Git"
        },
        "edit": "Düzenle",
        "yes": "Evet",
        "no": "Hayır",
        "new": "Yeni",
        "back": "Geri",
        "language": "Dil",
        "currency": "Para Birimi",
        "cancel": "Vazgeç",
        "send": "Gönder",
        "confirm": "Devam Et",
        "date": "Tarih",
        "save": "Kaydet",
        "report": "Bildir",
        "active": "Aktif",
        "passive": "Pasif",
        "remove": "Sil",
        "action": "İşlem",
        "search": "Ara",
        "all": "Tümü",
        "startDate": "Başlangıç Tarihi",
        "endDate": "Bitiş Tarihi",
        "close": "Kapat",
        "preview": "Önizleme",
        "today": "Bugün",
        "weekly": "Haftalık",
        "monthly": "Aylık",
        "yearly": "Yıllık",
        "viewAll": "Tümü Gör",
        "notification": "Bildirim",
        "download": "İndir",
        "optional": "İsteğe Bağlı",
        "permission": "Yetki",
        "manager": "Yönetici",
        "default": "Varsayılan",
        "status": "Durum",
        "sort": "Sırala",
        "createdAt": "Oluşturulma Tarihi",
        "chooseSelect": "Bir seçim yapın.",
        "chooseDate": "Tarih seçin.",
        "chooseTime": "Saat seçin.",
        "chooseDateAndTime": "Tarih ve saat seçin.",
        "selectGroup": "Lütfen bir grup seçin.",
        "individual": "Bireysel",
        "corporate": "Kurumsal",
        "cash": "Peşin",
        "system": "Sistem",
        "export": "Dışa Aktar",
        "overview": "Genel Bakış",
        "settings": "Ayarlar",
        "enable": "Etkinleştir",
        "homePage": "Anasayfa",
        "id": "ID",
        "true": "Doğru",
        "false": "Yanlış",
        "hour": "Saat",
        "minute": "Dakika",
        "second": "Saniye",
        "empty": "Boş",
        "indefinite": "Süresiz",
        "changePassword": "Şifre Değiştir",
        "poster": "Öne Çıkan Görsel",
        "you": "Sen",
        "min": "Minimum",
        "max": "Maksimum",
        "start": "Başlangıç",
        "end": "Bitiş",
        "ip": "IP",
        "userAgent": "Tarayıcı Bilgisi",
        "selfLogin": "Hesaba Giriş Yap"
    },
    "menu": {
        "dashboard": {
            "title": "Gösterge Paneli",
            "description": "Sistemin genel durumunu ve istatistiklerini görüntüleyin."
        },
        "ecommerce": {
            "title": "E-Ticaret Yönetimi",
            "description": "E-ticaret süreçlerini ve ürün yönetimini yönetin.",
            "product": {
                "title": "Ürünler",
                "description": "Ürünleri görüntüleyin ve yönetin.",
                "list": {
                    "title": "Ürün Listesi",
                    "description": "Tüm ürünlerin listesini görüntüleyin."
                },
                "buying": {
                    "title": "Satın Alma",
                    "description": "Tedarikçilerden yapılan satın alma işlemlerini yönetin."
                },
                "transfer": {
                    "title": "Transferler",
                    "description": "Depolar arası ürün transferlerini yönetin."
                },
                "stocks": {
                    "title": "Stok Sayımı",
                    "description": "Ürün stok sayımı ve envanter kontrol işlemlerini yönetin."
                },
                "collation": {
                    "title": "Tanımlamalar",
                    "description": "Ürün yönetimi için gerekli tanımlama ayarlarını yönetin.",
                    "category": {
                        "title": "Kategoriler",
                        "description": "Ürün kategorilerini oluşturun ve yönetin."
                    },
                    "brand": {
                        "title": "Markalar",
                        "description": "Ürün markalarını oluşturun ve yönetin."
                    },
                    "variant_types": {
                        "title": "Varyant Türleri",
                        "description": "Ürün varyant türlerini oluşturun ve yönetin."
                    },
                    "product_groups": {
                        "title": "Ürün Grupları",
                        "description": "Ürün gruplarını oluşturun ve yönetin."
                    },
                    "suppliers": {
                        "title": "Tedarikçiler",
                        "description": "Tedarikçi bilgilerini oluşturun ve yönetin."
                    },
                    "tags": {
                        "title": "Etiketler",
                        "description": "Ürün etiketlerini oluşturun ve yönetin."
                    },
                    "product_units": {
                        "title": "Ürün Birimleri",
                        "description": "Ürün birimlerini oluşturun ve yönetin."
                    },
                    "attribute": {
                        "title": "Özel Alanlar",
                        "description": "Özellik setlerini, özel alanları ve seçeneklerini yönetin."
                    }
                },
                "priceList": {
                    "title": "Fiyat Listesi",
                    "description": "Ürünlere ait fiyat listelerini görüntüleyin ve yönetin."
                },
                "productBarcode": {
                    "title": "Ürün Barkod Etiketi",
                    "description": "Ürün barkod etiketlerini oluşturun ve yazdırın."
                }
            },
            "stock": {
                "title": "Stok Yönetimi",
                "description": "Depoları, stok bakiyelerini ve stok süreçlerini yönetin.",
                "warehouses": {
                    "title": "Depolar",
                    "description": "Depo, mağaza ve sanal depoları tanımlayın ve yönetin."
                },
                "status": {
                    "title": "Stok Durumu",
                    "description": "Depo bazında stok bakiyelerini görüntüleyin, eşik ve düzeltme yapın."
                },
                "movements": {
                    "title": "Stok Hareketleri",
                    "description": "Tüm stok giriş/çıkış hareketlerini görüntüleyin."
                },
                "purchases": {
                    "title": "Satın Almalar",
                    "description": "Tedarikçi satın alma siparişlerini oluşturun ve mal kabul yapın."
                },
                "transfers": {
                    "title": "Transferler",
                    "description": "Depolar arası stok transferlerini yönetin."
                },
                "counts": {
                    "title": "Stok Sayımları",
                    "description": "Fiziksel stok sayımı oluşturun ve bakiyeleri düzeltin."
                }
            },
            "order": {
                "title": "Siparişler",
                "description": "Sipariş süreçlerini görüntüleyin ve yönetin.",
                "list": {
                    "title": "Sipariş Listesi",
                    "description": "Tüm siparişleri görüntüleyin ve sipariş detaylarını yönetin."
                },
                "drafts": {
                    "title": "Taslaklar",
                    "description": "Taslak olarak kaydedilen siparişleri görüntüleyin ve düzenleyin."
                },
                "abandonedCarts": {
                    "title": "Terk Edilmiş Sepetler",
                    "description": "Tamamlanmamış ve terk edilmiş sepet işlemlerini görüntüleyin."
                },
                "cartLinks": {
                    "title": "Sepet Linkleri",
                    "description": "Sepet paylaşım bağlantılarını yönetin."
                },
                "tags": {
                    "title": "Etiketler",
                    "description": "Sipariş etiketlerini oluşturun ve yönetin."
                },
                "giftCards": {
                    "title": "Hediye Kartları",
                    "description": "Hediye kartlarını oluşturun, düzenleyin ve yönetin."
                },
                "statuses": {
                    "title": "Sipariş Durumları",
                    "description": "Sipariş durum tanımlarını oluşturun ve yönetin."
                }
            },
            "customer": {
                "title": "Müşteriler",
                "description": "Müşteri hesaplarını ve müşteri yönetim süreçlerini yönetin.",
                "list": {
                    "title": "Müşteri Listesi",
                    "description": "Tüm müşterileri görüntüleyin ve müşteri bilgilerini yönetin."
                },
                "pendingApproval": {
                    "title": "Onay Bekleyenler",
                    "description": "Onay sürecinde olan müşteri hesaplarını görüntüleyin ve yönetin."
                },
                "customerGroups": {
                    "title": "Müşteri Grupları",
                    "description": "Müşteri gruplarını oluşturun ve yönetin."
                },
                "tags": {
                    "title": "Etiketler",
                    "description": "Müşteri etiketlerini oluşturun ve yönetin."
                }
            },
            "report": {
                "title": "Raporlar",
                "description": "Satış, sipariş ve sistem raporlarını görüntüleyin."
            },
            "salesChannels": {
                "title": "Satış Kanalları",
                "description": "Sistem geneli satış kanallarını yönetin (Web Sitesi, Mobil Uygulama, pazaryerleri…); siparişler kanala göre raporlanır."
            },
            "marketing": {
                "title": "Pazarlama",
                "description": "Pazarlama araçlarını ve kampanya yönetim süreçlerini yönetin.",
                "summary": {
                    "title": "Özet",
                    "description": "Pazarlama performansına ait genel istatistikleri görüntüleyin."
                },
                "emailSms": {
                    "title": "E-Posta & SMS",
                    "description": "E-posta ve SMS pazarlama kampanyalarını yönetin."
                },
                "automation": {
                    "title": "Otomasyon",
                    "description": "Otomatik pazarlama senaryolarını oluşturun ve yönetin."
                },
                "affiliateReports": {
                    "title": "Affiliate Raporları",
                    "description": "Affiliate performans raporlarını görüntüleyin."
                }
            },
            "discount": {
                "title": "İndirimler",
                "description": "İndirim ve kampanya yönetim işlemlerini yönetin.",
                "campaigns": {
                    "title": "Kampanyalar",
                    "description": "Kampanyaları oluşturun ve yönetin."
                },
                "couponCodes": {
                    "title": "Kupon Kodları",
                    "description": "İndirim kuponlarını oluşturun ve yönetin."
                },
                "campaignOffers": {
                    "title": "Kampanya Teklifleri",
                    "description": "Özel kampanya tekliflerini oluşturun ve yönetin."
                }
            },
            "app": {
                "title": "Uygulamalar",
                "description": "Sistem uygulamalarını ve entegrasyonlarını yönetin.",
                "market": {
                    "title": "Uygulama Marketi",
                    "description": "Yeni uygulamaları keşfedin ve yükleyin."
                },
                "myApps": {
                    "title": "Uygulamalarım",
                    "description": "Yüklü uygulamaları görüntüleyin ve yönetin."
                }
            }
        },
        "site": {
            "title": "Site Yönetimi",
            "description": "Site içeriğini, yöneticileri ve site ayarlarını yönetin.",
            "administrators": {
                "title": "Yöneticiler",
                "description": "Yönetici hesaplarını ve yetkilerini yönetin.",
                "admins": {
                    "title": "Yöneticiler",
                    "description": "Yönetici hesaplarını oluşturun ve yönetin."
                },
                "groups": {
                    "title": "Yönetici Grupları",
                    "description": "Yönetici gruplarını ve izinlerini yönetin."
                }
            },
            "content": {
                "title": "İçerik Yönetimi",
                "description": "Site içerik modüllerini oluşturun ve yönetin.",
                "themes": {
                    "title": "Temalarım",
                    "description": "Site temalarını yönetin ve özelleştirin."
                },
                "media": {
                    "title": "Medya Kütüphanesi",
                    "description": "Dosyaları yükleyin, klasörleyin ve yönetin."
                },
                "slider": {
                    "title": "Slider",
                    "description": "Ana sayfa slider içeriklerini yönetin."
                },
                "featured_products": {
                    "title": "Öne Çıkan Ürünler",
                    "description": "Öne çıkan ürün gruplarını ve listelerini yönetin."
                },
                "blog": {
                    "title": "Blog",
                    "description": "Blog yazılarını ve kategorilerini yönetin.",
                    "posts": {
                        "title": "İçerikler",
                        "description": "Blog yazılarını oluşturun ve yönetin."
                    },
                    "categories": {
                        "title": "Kategoriler",
                        "description": "Blog kategorilerini oluşturun ve yönetin."
                    }
                },
                "pages": {
                    "title": "Sayfalar",
                    "description": "Statik site sayfalarını (Hakkımızda, KVKK, gizlilik vb.) oluşturun ve yönetin."
                },
                "faq": {
                    "title": "Sıkça Sorulan Sorular",
                    "description": "Sıkça sorulan soruları oluşturun ve yönetin."
                },
                "forms": {
                    "title": "Form",
                    "description": "Formları ve form yanıtlarını yönetin."
                },
                "popup": {
                    "title": "Popup",
                    "description": "Site popup pencerelerini oluşturun ve yönetin."
                },
                "links": {
                    "title": "Link Yönetimi",
                    "description": "Menü ve bağlantıları oluşturun ve yönetin."
                },
                "menus": {
                    "title": "Menüler",
                    "description": "Header/footer menülerini ve öğelerini (link, dropdown, mega) yönetin."
                }
            },
            "localization": {
                "title": "Lokalizasyon",
                "description": "Dil, para birimi ve bölgesel ayarları yönetin.",
                "languages": {
                    "title": "Diller",
                    "description": "Site dillerini yönetin."
                },
                "currencies": {
                    "title": "Para Birimleri",
                    "description": "Para birimlerini ve kurlarını yönetin."
                },
                "taxes": {
                    "title": "Vergiler",
                    "description": "Vergi tanımlarını yönetin."
                },
                "countries": {
                    "title": "Ülkeler",
                    "description": "Ülke, il ve ilçeleri görüntüleyin."
                }
            },
            "settings": {
                "title": "Ayarlar",
                "description": "Site ve sistem ayarlarını yapılandırın.",
                "general": {
                    "title": "Genel Ayarlar",
                    "description": "Site, kayıt ve sistem değişkeni ayarlarını yapılandırın."
                },
                "register": {
                    "title": "Kayıt Ol Ayarları",
                    "description": "Üye kayıt (kayıt ol) ile ilgili ayarları yapılandırın."
                },
                "site": {
                    "title": "Site Ayarları",
                    "description": "Genel site ayarlarını yapılandırın.",
                    "homepage": {
                        "title": "Anasayfa Ayarları",
                        "description": "Anasayfa ile ilgili ayarları yapılandırın."
                    }
                },
                "theme": {
                    "title": "Tema Ayarları",
                    "description": "Aktif temanın renklerini yönetin."
                },
                "system_variables": {
                    "title": "Sistem Değişkenleri",
                    "description": "Sistem genelindeki değişkenleri yönetin."
                },
                "system": {
                    "title": "Sistem Ayarları",
                    "description": "Gelişmiş sistem ayarlarını yapılandırın.",
                    "register": {
                        "title": "Kayıt Ol Ayarları",
                        "description": "Üye kayıt (kayıt ol) ile ilgili ayarları yapılandırın."
                    }
                },
                "tracking_codes": {
                    "title": "İzleme Kodları",
                    "description": "Analitik ve izleme kodlarını yönetin."
                },
                "media_providers": {
                    "title": "Medya Sağlayıcıları",
                    "description": "Video/akış sağlayıcılarını ve hesaplarını yönetin."
                }
            }
        }
    },
    "messages": {
        "warning": "Uyarı",
        "success": "Başarılı",
        "error": "Hata",
        "sureAction": "Bu işlemi gerçekleştirmek istediğinizden emin misiniz? Lütfen dikkatli olun.",
        "sureConfirm": "Bu işlemi onaylamak istediğinizden emin misiniz?",
        "sureDelete": "Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        "actionOk": "İşleminiz başarıyla tamamlandı.",
        "copied": "kopyalandı",
        "deleteOk": "Silme işlemi başarıyla tamamlandı.",
        "copyOk": "Kayıt başarıyla kopyalandı. Yeni kaydı kullanmaya başlayabilirsiniz.",
        "copyLinkOk": "Link başarıyla kopyalandı.",
        "copyLinkError": "Link kopyalanırken bir hata oluştu.",
        "selectRow": "Lütfen işlem gerçekleştirmek için bir kayıt seçiniz.",
        "wait": "Lütfen bekleyiniz",
        "loading": "Veriler yükleniyor. Lütfen sabırlı olunuz.",
        "noResultFound": "Arama kriterlerinize uygun sonuç bulunamadı. Lütfen farklı kriterler kullanarak tekrar deneyiniz.",
        "errorOccurred": "Bir hata oluştu",
        "exportFailed": "Dışa aktarma başarısız oldu",
        "fillRequired": "Lütfen zorunlu alanları doldurun"
    },
    "btn": {
        "preview": "Önizleme",
        "new": "Yeni",
        "add": "Ekle",
        "create": "Oluştur",
        "copy": "Kopyala",
        "edit": "Düzenle",
        "detail": "Detay",
        "customerDelete": "Müşteriyi Sil",
        "delete": "Sil",
        "yes": "Evet",
        "no": "Hayır",
        "cancel": "Vazgeç",
        "close": "Kapat",
        "refresh": "Yenile",
        "categories": "Kategoriler",
        "export": "Dışa Aktar",
        "update": "Güncelle",
        "filter": "Filtrele",
        "ship": "Kargoya Ver",
        "save": "Kaydet",
        "saveAll": "Tümünü Kaydet",
        "select": "Seç",
        "selectFile": "Dosya Seç",
        "upload": "Yükle",
        "download": "İndir",
        "action": "İşlem",
        "previous": "Önceki",
        "ensuing": "Sonraki",
        "next": "İleri",
        "back": "Geri",
        "send": "Gönder",
        "ok": "Tamam",
        "clear": "Temizle",
        "tryAgain": "Tekrar Dene",
        "apply": "Uygula",
        "reset": "Sıfırla",
        "change": "Değiştir",
        "check": "Kontrol Et",
        "clone": "Klonla",
        "selectedRowEvent": "Seçili Kayıt İşlemleri"
    },
    "validation": {
        "required": "Bu alanı doldurmanız gerekmektedir.",
        "email": "Lütfen geçerli bir e-posta adresi giriniz.",
        "number": "Bu alana yalnızca sayı değeri girilmelidir.",
        "confirmed": "Girdiğiniz bilgiler onay ile eşleşmiyor. Lütfen kontrol edin.",
        "length": "Bu alanda en az 2 seçenek bulunmalıdır.",
        "password": "Lütfen güçlü ve geçerli bir şifre giriniz.",
        "passwordConfirmation": "Lütfen şifrenizi yeniden giriniz.",
        "dontMatchPassword": "Girdiğiniz şifreler birbiriyle eşleşmiyor. Lütfen tekrar deneyiniz."
    },
    "pages": {
        "login": {
            "title": "Giriş Yap",
            "description": "Devam etmek için hesabınıza giriş yapın",
            "back": {
                "title": "Henüz üye olmadın mı?",
                "buttonTitle": "Üye Ol"
            },
            "cols": {
                "customerID": "Müşteri Numarası",
                "email": "E - Posta",
                "password": "Şifre",
                "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
            },
            "successLogin": "Başarıyla giriş yaptınız. Hoş geldiniz!",
            "btnText": "Giriş Yap",
            "responseMessage": {
                "title": "Hata Oluştu",
                "invalid_credentials": "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
            },
            "placeholders": {
                "email": "ornek{'@'}ticatix.com",
                "password": "••••••••",
                "customerID": "Örn: 100234"
            }
        },
        "auth": {
            "banner": {
                "title": "Tek panel, tam kontrol",
                "content": "Ürün, sipariş, müşteri ve pazarlamayı tek yerden yönetin; anlık verilerle işletmenizi güvenle büyütün.",
                "theme": {
                    "light": "Aydınlık Mod",
                    "dark": "Koyu Mod",
                    "system": "Otomatik"
                }
            },
            "register": {
                "title": "Hesap Oluştur",
                "description": "Sınırsız erişim elde edin ve para kazanın",
                "login": {
                    "title": "Zaten hesabınız var mı?",
                    "signIn": "Giriş Yapın"
                },
                "cols": {
                    "firstname": "Ad",
                    "lastname": "Soyad",
                    "identificationNumber": "Kimlik No",
                    "email": "E-Posta",
                    "mobilePhone": "Telefon",
                    "birthDate": "Doğum Tarihi",
                    "password": "Şifre",
                    "passwordConfirmation": "Şifre Tekrar",
                    "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
                },
                "sureRegister": {
                    "title": "Kaydı tamamlamak istiyor musunuz?",
                    "description": "Kayıt olduktan sonra <b>e-posta</b> ve <b>telefon numarasını</b> değiştiremezsiniz, bu yüzden doğru bilgileri girdiğinizden emin olun."
                },
                "responseMessage": {
                    "success": "Başarılı şekilde kaydınızı tamamladınız! Hoş geldiniz!"
                },
                "verify": {
                    "title": "E-posta adresinizi doğrulayın",
                    "description": "E-posta almadınız mı? <a href='/auth/sign-up' class='kt-link kt-link-underlined kt-link-dashed'>Tekrar Dene</a>",
                    "buttonTitle": "Şimdilik Atla"
                }
            },
            "passwordReset": {
                "title": "Şifrenizi mi unuttunuz?",
                "description": "Şifrenizi sıfırlamak için E-posta adresinizi girin.",
                "back": {
                    "title": "Zaten üye misiniz?",
                    "buttonTitle": "Giriş Yap"
                },
                "cols": {
                    "customerID": "Müşteri Numarası",
                    "email": "E-Posta",
                    "confirmation": "Kabul ediyorum &amp; <a href='#' class='kt-link'>Şartlar ve koşullar</a>."
                },
                "responseMessage": {
                    "success": "Şifre sıfırlama talimatları e-posta adresinize gönderildi.",
                    "password_reset_rate_error": "Şifre sıfırlama talebinizi son talep zamanından 120 saniye sonra yapabilirsiniz."
                },
                "verify": {
                    "title": "Şifre Yenile",
                    "description": "Yeni şifrenizi onay kodu ile birlikte girin.",
                    "back": {
                        "title": "Zaten üye misiniz?",
                        "buttonTitle": "Giriş Yap"
                    },
                    "cols": {
                        "email": "E-Posta",
                        "password": "Şifre",
                        "passwordConfirmation": "Şifre Tekrar",
                        "code": "Onay Kodu"
                    },
                    "responseMessage": {
                        "success": "Şifreniz başarıyla sıfırlandı.",
                        "invalid_token": "Bu bağlantı geçerliliğini yitirmiş veya daha önce kullanılmış. Lütfen yeni bir bağlantı talep ediniz."
                    }
                },
                "confirmation": {
                    "title": "Şifreniz başarıyla sıfırlandı.",
                    "description": "Yaratıcı olmak için harika bir fırsat <a href='#' class='kt-link kt-link-underlined kt-link-dashed'>max{'@'}keenthemes.com</a> <br>okuyuculara bir fikir veriyor"
                }
            },
            "twoFactor": {
                "title": "İki Faktörlü Doğrulama",
                "description": "Gönderdiğimiz doğrulama kodunu girin",
                "phoneFormat": "******7859",
                "cols": {
                    "code": "6 haneli güvenlik kodunu girin"
                }
            },
            "deActive": {
                "title": "Hesabınız devre dışı bırakıldı",
                "description": "Harika fırsatlar elde edebilirsiniz. Daha fazla bilgi için lütfen bizimle iletişime geçiniz.",
                "btnText": "Ana Sayfaya Dön"
            }
        },
        "account": {
            "overview": {
                "title": "Profil Detayları",
                "cols": {
                    "name": "Ad",
                    "surname": "Soyad",
                    "email": "E-Posta",
                    "phone": "Telefon",
                    "role": "Rol"
                }
            },
            "settings": {
                "signInMethod": {
                    "title": "Giriş Yöntemi",
                    "emailAddress": "E-Posta Adresi",
                    "password": {
                        "title": "Şifre",
                        "cols": {
                            "currentPassword": "Mevcut Şifre",
                            "password": "Yeni Şifre",
                            "passwordConfirmation": "Yeni Şifre Tekrar"
                        },
                        "changePassword": "Şifre Değiştir",
                        "updatePassword": "Şifreyi Güncelle"
                    }
                }
            },
            "title": "Hesabım",
            "description": "Hesap bilgilerinizi görüntüleyin ve şifrenizi güncelleyin."
        },
        "dashboard": {
            "cols": {
                "title": "Başlık"
            },
            "greet": "Hoş geldiniz",
            "title": "Kontrol Paneli",
            "todayRevenue": "Bugünkü Ciro",
            "ordersToday": "{n} sipariş bugün",
            "newOrder": "Sipariş",
            "reports": "Raporlar",
            "salesTrend": "Satış Trendi",
            "trendSub": "Son 30 günün günlük cirosu",
            "trend30Total": "30 gün toplam",
            "orderStatus": "Sipariş Durumu",
            "noOrders": "Sipariş yok",
            "noOrdersYet": "Henüz sipariş bulunmuyor.",
            "noOrdersReceived": "Henüz sipariş alınmadı.",
            "recentOrders": "Son Siparişler",
            "all": "Tümü",
            "guest": "Misafir",
            "topProducts": "En Çok Satan Ürünler",
            "report": "Rapor",
            "unit": "adet",
            "noSales": "Satış yok",
            "noSalesYet": "Henüz ürün satışı yok.",
            "revenue": "Ciro",
            "total": "Toplam",
            "ordersSuffix": "sipariş",
            "loadError": "Veriler yüklenemedi.",
            "kpi": {
                "monthRevenue": "Bu Ay Ciro",
                "monthOrders": "Bu Ay Sipariş",
                "avgOrder": "Ortalama Sepet",
                "customers": "Müşteri",
                "perOrder": "sipariş başına",
                "ordered": "sipariş veren"
            },
            "quick": {
                "products": "Ürünler",
                "productsDesc": "Katalog yönetimi",
                "orders": "Siparişler",
                "ordersDesc": "Sipariş yönetimi",
                "customers": "Müşteriler",
                "customersDesc": "Müşteri yönetimi",
                "carts": "Terk Edilen Sepetler",
                "cartsDesc": "Kurtarma fırsatları",
                "campaigns": "Kampanyalar",
                "campaignsDesc": "İndirim & promosyon",
                "apps": "Uygulamalar",
                "appsDesc": "Entegrasyonlar"
            }
        },
        "ecommerce": {
            "marketing": {
                "emailSms": {
                    "newTitle": "Yeni Kampanya",
                    "editTitle": "Kampanyayı Düzenle",
                    "channel": "Kanal",
                    "channels": {
                        "email": "E-posta",
                        "sms": "SMS",
                        "push": "Push"
                    },
                    "campaignName": "Kampanya Adı",
                    "namePh": "Örn. Yıl sonu indirim duyurusu",
                    "audience": "Hedef Kitle",
                    "customers": "müşteri",
                    "matchLabel": "Kurallardan",
                    "matchAll": "Hepsini sağlayan",
                    "matchAny": "Herhangi birini sağlayan",
                    "allNote": "Kural eklemezsen bu kanala uygun (iletişim bilgisi olan) TÜM müşterilere gönderilir.",
                    "searchProduct": "Ürün ara...",
                    "selectTag": "Etiket seç",
                    "selectGroup": "Grup seç",
                    "addRule": "Kural Ekle",
                    "content": "İçerik",
                    "subject": "E-posta Konusu",
                    "subjectPh": "{customer.name}, sana özel!",
                    "smsPh": "Kısa mesaj metni. {customer.name} kullanabilirsin.",
                    "chars": "karakter",
                    "pushTitle": "Bildirim Başlığı",
                    "pushTitlePh": "Örn. Yeni Kampanya!",
                    "message": "Mesaj",
                    "pushMsgPh": "Push bildirim metni",
                    "pushHint": "Push, OneSignal ile TÜM abone kullanıcılara yayınlanır (sağlayıcı gerektirir); hedef kitle sayımı bilgilendirme amaçlıdır.",
                    "saveDraft": "Taslak Kaydet",
                    "send": "Gönder",
                    "queued": "Kampanya gönderime alındı.",
                    "nameRequired": "Kampanya adı zorunludur.",
                    "emailRequired": "Önce e-posta içeriğini tasarlayın.",
                    "messageRequired": "Mesaj metni zorunludur.",
                    "reach": "Ulaşılan",
                    "sentShort": "gönderildi",
                    "failedShort": "başarısız",
                    "date": "Tarih",
                    "confirmSend": "Bu kampanya ≈ {n} müşteriye gönderilecek. Onaylıyor musun?",
                    "status": {
                        "draft": "Taslak",
                        "scheduled": "Zamanlanmış",
                        "sending": "Gönderiliyor",
                        "sent": "Gönderildi",
                        "failed": "Başarısız"
                    }
                },
                "automation": {
                    "addTitle": "Otomasyon Oluştur",
                    "editTitle": "Otomasyonu Düzenle",
                    "builderHint": "Tetikleyici, koşul ve aksiyonları sürükleyip bağlayarak akışı kurun.",
                    "namePh": "Örn. Sipariş sonrası teşekkür e-postası",
                    "description": "Açıklama",
                    "descPh": "Bu otomasyon ne yapıyor?",
                    "palette": "Bileşenler",
                    "settings": "Ayarlar",
                    "selectNode": "Ayarlarını düzenlemek için bir düğüm seçin.",
                    "noTrigger": "Tetikleyici yok",
                    "namePh2": "Otomasyon adı",
                    "nameRequired": "Otomasyon adı zorunludur.",
                    "triggerRequired": "En az bir tetikleyici eklemelisiniz.",
                    "oneTrigger": "Bir akışta yalnızca bir tetikleyici olabilir.",
                    "removeNode": "Düğümü Sil",
                    "matchMode": "Eşleşme",
                    "matchAll": "Tümü (AND)",
                    "matchAny": "Herhangi biri (OR)",
                    "needTrigger": "Koşul alanları için önce bir tetikleyici ekleyin.",
                    "condition": "Koşul",
                    "addCondition": "Koşul Ekle",
                    "field": "Alan",
                    "value": "Değer",
                    "selectTag": "Etiket seç",
                    "selectGroup": "Grup seç",
                    "variables": "Kullanılabilir değişkenler (tıkla kopyala)",
                    "groups": {
                        "trigger": "Tetikleyici",
                        "condition": "Koşul",
                        "ab_test": "A/B Test",
                        "delay": "Bekleme",
                        "action": "Aksiyon"
                    },
                    "canvas": {
                        "empty": "Soldaki paletten bir tetikleyici sürükleyerek başlayın.",
                        "yes": "Evet",
                        "no": "Hayır",
                        "conditionWord": "koşul",
                        "noCondition": "Koşul tanımlanmadı",
                        "splitWord": "bölme",
                        "waitWord": "bekle",
                        "noDuration": "Süre ayarlanmadı",
                        "notSet": "Ayarlanmadı",
                        "zoomIn": "Yakınlaştır",
                        "zoomOut": "Uzaklaştır",
                        "fit": "Sığdır",
                        "units": {
                            "minute": "dakika",
                            "hour": "saat",
                            "day": "gün",
                            "week": "hafta",
                            "month": "ay"
                        }
                    },
                    "trig": {
                        "order_created": "Sipariş Oluşturuldu",
                        "order_status_changed": "Sipariş Durumu Değişti",
                        "order_paid": "Sipariş Ödendi",
                        "order_cancelled": "Sipariş İptal Edildi",
                        "customer_registered": "Yeni Müşteri Kaydı",
                        "cart_abandoned": "Sepet Terk Edildi"
                    },
                    "cols": {
                        "name": "Otomasyon",
                        "trigger": "Tetikleyici",
                        "runs": "Çalıştırma",
                        "updated": "Güncelleme"
                    },
                    "email": {
                        "title": "E-posta Tasarımı",
                        "contentLabel": "E-posta İçeriği",
                        "notDesigned": "E-posta henüz tasarlanmadı",
                        "design": "E-posta Tasarla",
                        "edit": "E-postayı Düzenle",
                        "templates": "Hazır Şablonlar",
                        "tplConfirm": "Mevcut tasarımın silinip seçtiğin şablonla değiştirilecek. Devam edilsin mi?",
                        "heroTitle": "Başlık",
                        "heroSubtitle": "Alt Başlık",
                        "titleColor": "Başlık Rengi",
                        "subtitleColor": "Alt Başlık Rengi",
                        "padding": "İç Boşluk (px)",
                        "icon": "İkon",
                        "iconColor": "İkon Rengi",
                        "itemsHeading": "Bölüm Başlığı",
                        "itemsHeadingPh": "Örn. Sipariş Özeti",
                        "itemsNote": "Gerçek ürünler gönderim anında eklenir",
                        "itemsInfo": "Bu blok gönderim sırasında siparişteki / sepetteki gerçek ürünlerle (görsel, adet, tutar) otomatik doldurulur.",
                        "tpl": {
                            "welcome": "Hoş Geldiniz",
                            "order": "Sipariş Onayı",
                            "promo": "Kampanya",
                            "cart": "Sepet Hatırlatma"
                        },
                        "block": {
                            "hero": "Hero Banner",
                            "logo": "Logo",
                            "heading": "Başlık",
                            "text": "Metin",
                            "icon": "İkon",
                            "features": "İkonlu Liste",
                            "items": "Ürünler",
                            "button": "Buton",
                            "image": "Görsel",
                            "social": "Sosyal",
                            "divider": "Ayırıcı",
                            "spacer": "Boşluk",
                            "footer": "Alt Bilgi"
                        },
                        "featTitle": "Başlık",
                        "featDesc": "Açıklama",
                        "blocks": "Bloklar",
                        "global": "Genel Ayarlar",
                        "bg": "Arka Plan",
                        "cardBg": "İçerik Rengi",
                        "textColor": "Metin Rengi",
                        "width": "Genişlik (px)",
                        "radius": "Köşe Yuvarlaklığı",
                        "content": "İçerik",
                        "logoText": "Logo Metni",
                        "image": "Görsel URL",
                        "logoHint": "Logo görseli seçin ya da URL girin (boşsa metin gösterilir).",
                        "widthPx": "Genişlik (px)",
                        "btnText": "Buton Metni",
                        "btnUrl": "Buton Linki",
                        "btnBg": "Buton Rengi",
                        "btnColor": "Yazı Rengi",
                        "link": "Bağlantı (URL)",
                        "widthPct": "Genişlik (%)",
                        "color": "Renk",
                        "height": "Yükseklik (px)",
                        "align": "Hizalama",
                        "size": "Boyut",
                        "removeBlock": "Bloğu Sil",
                        "selectBlock": "Düzenlemek için bir blok seçin.",
                        "emptyHint": "Soldaki panelden blok ekleyerek e-postanızı oluşturun.",
                        "dragMove": "Taşı",
                        "duplicate": "Kopyala",
                        "sampleProduct": "Örnek Ürün",
                        "qtyLabel": "Adet"
                    }
                },
                "summaryPage": {
                    "eyebrow": "Pazarlama",
                    "title": "Pazarlama Merkezi",
                    "subtitle": "Kampanyalarını, otomasyonlarını ve müşteri ilgisini tek ekrandan takip et.",
                    "newCampaign": "Yeni Kampanya",
                    "newAutomation": "Yeni Otomasyon",
                    "viewAll": "Tümü",
                    "loadError": "Özet verileri yüklenemedi.",
                    "kpi": {
                        "campaigns": "Kampanya",
                        "sent": "gönderildi",
                        "recipients": "Ulaşılan Alıcı",
                        "delivered": "iletildi",
                        "automations": "Aktif Otomasyon",
                        "totalShort": "toplam",
                        "runs": "Otomasyon Çalışması",
                        "runsSub": "toplam tetikleme",
                        "favorites": "Favori",
                        "customers": "müşteri"
                    },
                    "channels": {
                        "title": "Kanal Dağılımı",
                        "subtitle": "Kanala göre kampanya sayısı",
                        "email": "E-posta",
                        "sms": "SMS",
                        "push": "Push Bildirim",
                        "noData": "Henüz kampanya yok"
                    },
                    "campaigns": {
                        "title": "Son Kampanyalar",
                        "recipients": "alıcı",
                        "empty": "Henüz kampanya yok",
                        "emptyHint": "İlk toplu e-posta/SMS kampanyanı oluştur."
                    },
                    "automations": {
                        "title": "En Aktif Otomasyonlar",
                        "runs": "çalışma",
                        "active": "Aktif",
                        "passive": "Pasif",
                        "empty": "Henüz otomasyon yok",
                        "emptyHint": "Tetikleyici tabanlı ilk otomasyonunu kur."
                    },
                    "favorites": {
                        "title": "En Çok Favorilenen Ürünler",
                        "times": "kez",
                        "empty": "Henüz favori yok",
                        "emptyHint": "Müşteriler ürünleri favorilediğinde burada görünür."
                    },
                    "status": {
                        "draft": "Taslak",
                        "scheduled": "Zamanlanmış",
                        "sending": "Gönderiliyor",
                        "sent": "Gönderildi",
                        "failed": "Başarısız"
                    }
                }
            },
            "report": {
                "refresh": "Yenile",
                "refreshed": "Rapor güncellendi",
                "loadError": "Rapor verileri yüklenirken bir hata oluştu.",
                "empty": "Kayıt bulunamadı",
                "updatedNote": "Rapor verileri performans için 24 saat önbelleğe alınır; en güncel veri için Yenile'ye basın.",
                "searchProduct": "Ürün ara (en az 2 harf)…",
                "searchCustomer": "Müşteri ara (en az 2 harf)…",
                "prev": "Önceki",
                "next": "Sonraki",
                "goToday": "Bugüne dön",
                "pickProduct": "Bir ürün seçin",
                "pickCustomer": "Bir müşteri seçin",
                "pickProductHint": "Raporu görüntülemek için yukarıdaki arama kutusundan ürün seçin.",
                "pickCustomerHint": "Raporu görüntülemek için yukarıdaki arama kutusundan müşteri seçin.",
                "vsPrev": "önceki döneme göre",
                "salesTrend": "Satış Trendi",
                "revenueTrend": "Ciro Trendi",
                "periodTotal": "Dönem toplamı",
                "orderStatus": "Sipariş Durumu",
                "noOrdersPeriod": "Bu dönemde sipariş yok",
                "customerSummary": "Müşteri Özeti",
                "lifetimeOrders": "Yaşam boyu sipariş",
                "lifetimeValue": "Yaşam boyu değer",
                "avgOrder": "Ortalama sepet",
                "firstOrder": "İlk sipariş",
                "lastOrder": "Son sipariş",
                "topBought": "En Çok Aldığı Ürünler",
                "topSold": "En Çok Satan Ürünler",
                "unit": "adet",
                "note": "Rakamlar iptal/iade/ödeme bekleyen siparişler hariç hesaplanır. Genel sayılar tüm zamanları kapsar.",
                "totalOrders": "Toplam Sipariş",
                "ordersSuffix": "sipariş",
                "period": {
                    "day": "Günlük",
                    "week": "Haftalık",
                    "month": "Aylık",
                    "year": "Yıllık"
                },
                "mode": {
                    "general": "Genel",
                    "product": "Ürün",
                    "customer": "Müşteri"
                },
                "trend": {
                    "hourly": "Saatlik {n}",
                    "daily": "Günlük {n}",
                    "dailyRange": "Günlük {n} (Pzt–Paz)",
                    "monthly": "Aylık {n}"
                },
                "noun": {
                    "salesUnit": "satış (adet)",
                    "spending": "harcama",
                    "revenue": "ciro"
                },
                "kpi": {
                    "soldUnits": "Satılan Adet",
                    "revenue": "Ciro",
                    "orders": "Sipariş",
                    "containingThis": "bu ürünü içeren",
                    "allTime": "Tüm Zaman",
                    "periodOrders": "Dönem Siparişi",
                    "periodSpending": "Dönem Harcaması",
                    "lifetimeValue": "Yaşam Boyu Değer",
                    "avgOrderShort": "Ort. Sepet",
                    "lifetime": "yaşam boyu",
                    "periodRevenue": "Dönem Cirosu",
                    "avgOrder": "Ortalama Sepet",
                    "totalProducts": "Toplam Ürün",
                    "registeredProducts": "kayıtlı ürün (tüm zamanlar)",
                    "perOrder": "sipariş başına"
                }
            },
            "salesChannels": {
                "addTitle": "Kanal Ekle",
                "editTitle": "Kanalı Düzenle",
                "cols": {
                    "name": "Ad",
                    "code": "Kod",
                    "sort": "Sıra"
                },
                "custom": "Özel",
                "systemChannelHint": "Sistem kanalı — checkout ve entegrasyonlar bu koda referans verdiği için silinemez.",
                "namePlaceholder": "Instagram, Telefon…",
                "warehouses": {
                    "action": "Depolar",
                    "title": "Kanal Depo Ataması",
                    "hint": "Bu kanaldan gelen siparişlerin hangi depodan (öncelik sırasıyla) karşılanacağını ve kanala bildirilen stok miktarını belirler.",
                    "empty": "Bu kanala henüz depo atanmadı — tüm depolar kullanılır.",
                    "warehouse": "Depo",
                    "priority": "Öncelik",
                    "stockRatio": "Stok Oranı (%)",
                    "safetyStock": "Emniyet Stoğu",
                    "add": "Depo Ekle"
                }
            },
            "stock": {
                "warehouse": {
                    "title": "Depolar",
                    "empty": "Henüz depo tanımlanmadı. İlk deponuzu ekleyin.",
                    "addTitle": "Depo Ekle",
                    "editTitle": "Depo Düzenle",
                    "default": "Varsayılan",
                    "isDefault": "Varsayılan Depo",
                    "isDefaultHint": "Sistemde tek varsayılan depo bulunur.",
                    "isSellable": "Satılabilir",
                    "isSellableHint": "Kapalıysa satışta kullanılmaz (ör. iade deposu).",
                    "cols": {
                        "name": "Ad",
                        "code": "Kod",
                        "type": "Tip",
                        "city": "Şehir",
                        "address": "Adres",
                        "priority": "Öncelik",
                        "sellable": "Satılabilir"
                    },
                    "types": {
                        "warehouse": "Depo",
                        "store": "Mağaza",
                        "virtual": "Sanal"
                    }
                },
                "status": {
                    "title": "Stok Durumu",
                    "viewMovements": "Hareketleri Görüntüle",
                    "searchPlaceholder": "Ürün ara…",
                    "stockCode": "Stok Kodu",
                    "stockState": "Stok Durumu",
                    "states": {
                        "in_stock": "Stokta",
                        "out_of_stock": "Tükendi",
                        "critical": "Kritik"
                    },
                    "criticalOnly": "Yalnızca kritik",
                    "criticalHint": "Kullanılabilir stok, minimum eşiğin altında veya eşit.",
                    "editLevels": "Eşikleri Düzenle",
                    "maxLevel": "Maksimum Eşik",
                    "shelf": "Raf Konumu",
                    "adjust": "Stok Düzelt",
                    "adjustTitle": "Manuel Stok Düzeltme",
                    "current": "Mevcut",
                    "targetQuantity": "Hedef Miktar",
                    "note": "Not",
                    "notePlaceholder": "Düzeltme nedeni (zorunlu)",
                    "cols": {
                        "warehouse": "Depo",
                        "product": "Ürün",
                        "quantity": "Miktar",
                        "reserved": "Rezerve",
                        "incoming": "Gelen",
                        "available": "Kullanılabilir",
                        "min": "Min. Eşik"
                    }
                },
                "movement": {
                    "title": "Stok Hareketleri",
                    "dateRange": "Tarih Aralığı",
                    "cols": {
                        "date": "Tarih",
                        "warehouse": "Depo",
                        "product": "Ürün",
                        "type": "Tip",
                        "quantity": "Miktar",
                        "after": "Sonraki",
                        "reference": "Referans",
                        "note": "Not"
                    },
                    "types": {
                        "initial": "Açılış",
                        "purchase_in": "Satın Alma Girişi",
                        "sale_out": "Satış Çıkışı",
                        "transfer_in": "Transfer Girişi",
                        "transfer_out": "Transfer Çıkışı",
                        "adjustment_in": "Düzeltme Girişi",
                        "adjustment_out": "Düzeltme Çıkışı",
                        "return_in": "İade Girişi",
                        "count_correction": "Sayım Düzeltmesi"
                    }
                },
                "purchase": {
                    "title": "Satın Almalar",
                    "empty": "Henüz satın alma siparişi yok. Yeni bir taslak oluşturun.",
                    "itemsShort": "Kalem",
                    "addTitle": "Yeni Satın Alma",
                    "expectedDate": "Beklenen Tarih",
                    "createdAt": "Oluşturma Tarihi",
                    "total": "Tutar",
                    "currency": "Para Birimi",
                    "exchangeRate": "Kur",
                    "items": "Kalemler",
                    "addItem": "Kalem Ekle",
                    "noItems": "Henüz kalem eklenmedi.",
                    "selectProduct": "Ürün seçin…",
                    "variant": "Varyant",
                    "variants": "Varyantlar",
                    "selectVariant": "Varyant seçin…",
                    "variantRequired": "Varyantlı ürünlerde kombinasyon seçmelisiniz.",
                    "bulkApplyHint": "hepsine uygula:",
                    "applyAll": "Tümüne uygula",
                    "unitPrice": "Birim Fiyat",
                    "taxRate": "Vergi %",
                    "received": "Alınan",
                    "receiveNow": "Şimdi Al",
                    "receiveAll": "Hepsini Al",
                    "fillRemaining": "Kalanı doldur ({n})",
                    "doReceive": "Mal Kabul",
                    "createDraft": "Taslak Oluştur",
                    "cols": {
                        "code": "Kod",
                        "warehouse": "Depo",
                        "supplier": "Tedarikçi",
                        "product": "Ürün",
                        "quantity": "Miktar"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "ordered": "Sipariş Verildi",
                        "partially_received": "Kısmen Alındı",
                        "received": "Alındı",
                        "cancelled": "İptal"
                    }
                },
                "transfer": {
                    "title": "Transferler",
                    "empty": "Henüz transfer yok. Yeni bir taslak oluşturun.",
                    "itemsShort": "Kalem",
                    "addTitle": "Yeni Transfer",
                    "createdAt": "Oluşturma Tarihi",
                    "route": "Güzergah",
                    "fromWarehouse": "Kaynak Depo",
                    "toWarehouse": "Hedef Depo",
                    "items": "Kalemler",
                    "addItem": "Kalem Ekle",
                    "noItems": "Henüz kalem eklenmedi.",
                    "selectProduct": "Ürün seçin…",
                    "variant": "Varyant",
                    "selectVariant": "Varyant seçin…",
                    "variantRequired": "Varyantlı ürünlerde kombinasyon seçmelisiniz.",
                    "createDraft": "Taslak Oluştur",
                    "cols": {
                        "code": "Kod",
                        "product": "Ürün",
                        "quantity": "Miktar"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "in_transit": "Yolda",
                        "completed": "Tamamlandı",
                        "cancelled": "İptal"
                    }
                },
                "count": {
                    "title": "Stok Sayımları",
                    "empty": "Henüz stok sayımı yok. Yeni bir sayım oluşturun.",
                    "addTitle": "Yeni Sayım",
                    "createdAt": "Oluşturma Tarihi",
                    "completedAt": "Tamamlanma Tarihi",
                    "note": "Not",
                    "notePlaceholder": "Örn. Yıl sonu sayımı",
                    "startHint": "Sayımı başlatınca mevcut bakiyeler beklenen miktar olarak fotoğraflanır.",
                    "categories": "Kategoriler (kapsam)",
                    "categoriesHint": "Boş bırakılırsa tüm depo sayıma dahil edilir.",
                    "allWarehouse": "Tüm depo",
                    "start": "Sayımı Başlat",
                    "saveCounts": "Sayımı Kaydet",
                    "complete": "Tamamla",
                    "completeConfirm": "Sayım tamamlanacak ve farklar için stok düzeltmesi yapılacak. Devam edilsin mi?",
                    "expected": "Beklenen",
                    "counted": "Sayılan",
                    "fillAll": "Beklenenle Doldur",
                    "fillExpected": "Beklenen ({n}) ile doldur",
                    "diff": "Fark",
                    "noLines": "Sayım satırı bulunamadı.",
                    "cols": {
                        "code": "Kod",
                        "warehouse": "Depo",
                        "note": "Not",
                        "product": "Ürün"
                    },
                    "statuses": {
                        "draft": "Taslak",
                        "in_progress": "Devam Ediyor",
                        "completed": "Tamamlandı",
                        "cancelled": "İptal"
                    }
                }
            },
            "tags": {
                "addTitle": "Yeni Etiket",
                "editTitle": "Etiketi Düzenle",
                "nameLabel": "Etiket Adı",
                "namePlaceholder": "Etiket adı",
                "visibilityLabel": "Görünürlük",
                "visible": "Görünür",
                "hidden": "Gizli",
                "sortLabel": "Sıralama",
                "cols": {
                    "tag": "Etiket",
                    "visibility": "Görünürlük",
                    "sort": "Sıralama",
                    "usage": "Kullanım",
                    "productCount": "Ürün Sayısı",
                    "orderCount": "Sipariş Sayısı",
                    "customerCount": "Müşteri Sayısı"
                },
                "createOk": "Etiket eklendi",
                "updateOk": "Etiket güncellendi"
            },
            "order": {
                "giftCards": {
                    "addTitle": "Hediye Kartı Oluştur",
                    "editTitle": "Hediye Kartını Düzenle",
                    "cardInfo": "Hediye Kartı Bilgileri",
                    "codeLabel": "Hediye Kartı Kodu",
                    "codePlaceholder": "Örn. YILBASI2026 (maks. 20)",
                    "generate": "Kod Oluştur",
                    "currency": "Para Birimi",
                    "value": "Hediye Kartı Değeri",
                    "currentBalance": "Mevcut Bakiye",
                    "usedAmount": "Kullanılan",
                    "requirements": "Gereksinimler",
                    "minAmount": "Minimum Sipariş Tutarı",
                    "minAmountHint": "Kartın geçerli olması için sepetin ulaşması gereken minimum tutar (boşsa sınır yok).",
                    "noMinAmount": "Sınır yok",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "customer": "Müşteri",
                    "searchCustomer": "Müşteri adı ile arayın…",
                    "customerHint": "Boş bırakılırsa hediye kartı herkes tarafından kullanılabilir.",
                    "anyCustomer": "Herkes",
                    "salesChannel": "Satış Kanalı",
                    "allChannels": "Tüm kanallar",
                    "salesChannelHint": "Kartın geçerli olacağı satış kanalı (boşsa tüm kanallarda geçerli).",
                    "balanceOps": "Bakiye & İşlem Geçmişi",
                    "adjustBalance": "Bakiye Ayarla",
                    "adjustPlaceholder": "Örn. -100 veya 250",
                    "adjustNote": "Açıklama (opsiyonel)",
                    "adjustHint": "Pozitif tutar bakiye ekler, negatif tutar düşer. Bakiye 0'ın altına inemez.",
                    "apply": "Uygula",
                    "adjustOk": "Bakiye güncellendi",
                    "errBalanceNegative": "Bakiye 0'ın altına inemez.",
                    "history": "İşlem Geçmişi",
                    "noHistory": "Henüz işlem yok.",
                    "createOk": "Hediye kartı oluşturuldu",
                    "updateOk": "Hediye kartı güncellendi",
                    "states": {
                        "active": "Aktif",
                        "passive": "Pasif",
                        "depleted": "Tükendi",
                        "expired": "Süresi Doldu",
                        "scheduled": "Zamanlanmış",
                        "usable": "Kullanılabilir"
                    },
                    "tx": {
                        "issue": "Açılış",
                        "redeem": "Kullanım",
                        "refund": "İade",
                        "adjust": "Düzeltme"
                    },
                    "cols": {
                        "code": "Kod",
                        "balance": "Bakiye",
                        "customer": "Müşteri",
                        "dates": "Geçerlilik"
                    }
                },
                "cartLinks": {
                    "addTitle": "Sepet Linki Oluştur",
                    "editTitle": "Sepet Linkini Düzenle",
                    "general": "Genel",
                    "cols": {
                        "title": "Başlık",
                        "items": "Ürünler",
                        "coupon": "Kupon",
                        "stats": "İstatistik",
                        "expires": "Son Geçerlilik"
                    },
                    "code": "Kod",
                    "product": "ürün",
                    "viewCount": "Görüntülenme",
                    "orderCount": "Sipariş",
                    "copyUrl": "Linki kopyala",
                    "urlCopied": "Link panoya kopyalandı.",
                    "titlePlaceholder": "Ahmet Bey WhatsApp",
                    "titleHint": "Yalnızca panelde görünen not; müşteriye gösterilmez.",
                    "noExpiry": "Süresiz",
                    "itemsTitle": "Ürünler",
                    "addProduct": "Ürün Ekle",
                    "noItems": "Linke en az bir ürün ekleyin.",
                    "selectProduct": "Ürün seçin",
                    "searchProduct": "Ürün adı ile arayın…",
                    "selectVariant": "Varyant seçin",
                    "noVariant": "Varyant yok",
                    "personalizations": "Kişiselleştirmeler",
                    "fillRequiredPers": "Zorunlu kişiselleştirme alanlarını doldurun.",
                    "requiredFileBlock": "Bu üründe zorunlu dosya tipi kişiselleştirme var — panelden dosya yüklenemediği için ürün linke eklenemez. Alanı ürün ekranından zorunlu olmaktan çıkarabilirsiniz.",
                    "fileNotSupported": "Dosya alanı panelden doldurulamaz; boş bırakılır.",
                    "itemError": "{row}. üründe hata: {error}",
                    "errors": {
                        "requiredVariant": "{row}. ürün için varyant seçmelisiniz.",
                        "invalidVariant": "{row}. üründe seçilen varyant geçersiz.",
                        "invalidProduct": "{row}. ürün satışta değil (pasif ya da satış tarihi dışında).",
                        "invalidQuantity": "{row}. ürünün adedi geçersiz.",
                        "personalizationRequired": "{row}. üründe zorunlu kişiselleştirme alanı ({name}) doldurulmamış.",
                        "invalidPersValue": "{row}. üründe kişiselleştirme değeri geçersiz (listede olmayan seçim ya da geçersiz tarih).",
                        "unsupportedPers": "{row}. üründe ürüne ait olmayan bir kişiselleştirme alanı gönderildi.",
                        "persValueTooLong": "{row}. üründe kişiselleştirme metni karakter limitini aşıyor.",
                        "persDependencyNotMet": "{row}. üründe bağımlı alan, bağlı olduğu alan boşken doldurulmuş."
                    }
                },
                "list": {
                    "cols": {
                        "order": "Sipariş",
                        "customer": "Müşteri",
                        "items": "Ürün",
                        "total": "Tutar",
                        "payment": "Ödeme",
                        "status": "Durum",
                        "date": "Tarih"
                    },
                    "vat": "KDV",
                    "installment": "taksit",
                    "shipConfirm": "{count} sipariş kargoya verilecek. Onaylıyor musunuz?",
                    "shipOk": "Siparişler kargoya verildi"
                },
                "statuses": {
                    "system": "Sistem",
                    "custom": "Özel",
                    "addTitle": "Yeni Durum",
                    "editTitle": "Durumu Düzenle",
                    "codeLabel": "Kod",
                    "nameLabel": "Ad",
                    "namePlaceholder": "Durum adı",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "type": "Tür"
                    },
                    "updateOk": "Durum güncellendi",
                    "createOk": "Durum eklendi"
                },
                "create": {
                    "title": "Yeni Sipariş",
                    "subtitle": "Manuel olarak yeni bir sipariş oluşturun.",
                    "createOrder": "Siparişi Oluştur",
                    "products": "Ürünler",
                    "addProduct": "Ürün Ekle",
                    "product": "Ürün",
                    "searchProduct": "Ürün ara…",
                    "variant": "Varyant",
                    "selectVariant": "Varyant kombinasyonu seçin",
                    "variantRequired": "Varyantlı ürünler için varyant seçimi zorunludur",
                    "quantity": "Adet",
                    "usageStart": "Kullanım Başlangıç",
                    "usageEnd": "Kullanım Bitiş",
                    "optional": "Opsiyonel",
                    "loadingExtras": "Eklenti ve paket öğeleri yükleniyor…",
                    "addons": "Eklentiler",
                    "packageItems": "Paket Öğeleri",
                    "customUsageStart": "Özel kullanım başl.",
                    "customUsageEnd": "Özel kullanım bitiş",
                    "customer": "Müşteri",
                    "searchCustomer": "Müşteri ara…",
                    "address": "Adres",
                    "selectAddress": "Adres seçin",
                    "selectCustomerFirst": "Önce müşteri seçin",
                    "noCustomerAddress": "Bu müşterinin kayıtlı adresi yok.",
                    "orderStatus": "Sipariş Durumu",
                    "productDetailFail": "Ürün detayları alınamadı",
                    "addressFetchFail": "Adresler alınamadı",
                    "addAtLeastOneProduct": "En az bir ürün ekleyin",
                    "createOk": "Sipariş oluşturuldu"
                },
                "detail": {
                    "title": "Sipariş Detayı",
                    "subtitle": "Sipariş bilgilerini görüntüleyin.",
                    "orderNo": "Sipariş #{id}",
                    "products": "Ürünler",
                    "cols": {
                        "product": "Ürün",
                        "quantity": "Adet",
                        "subtotal": "Ara Toplam",
                        "total": "Toplam"
                    },
                    "variantNo": "Varyant #{id}",
                    "noProducts": "Ürün bulunmuyor",
                    "summary": "Özet",
                    "vat": "KDV",
                    "shipping": "Kargo",
                    "usageDates": "Kullanım Tarihleri",
                    "notes": "Notlar",
                    "notePlaceholder": "Sipariş notu ekleyin…",
                    "addNote": "Not Ekle",
                    "noNotes": "Henüz not eklenmemiş",
                    "customer": "Müşteri",
                    "deliveryAddress": "Teslimat Adresi",
                    "payment": "Ödeme",
                    "method": "Yöntem",
                    "subMethod": "Alt Yöntem",
                    "installmentLabel": "Taksit",
                    "paid": "Ödenen",
                    "remainingCollection": "Kalan Tahsilat",
                    "addCollection": "Tahsilat Ekle",
                    "amount": "Tutar",
                    "collectAllShort": "Tümü",
                    "collectAllTooltip": "Tümünü Tahsilat Et (kalan tutarı yazar)",
                    "noteOptional": "Not (opsiyonel)",
                    "weight": "Ağırlık",
                    "trackingNumber": "Takip Numarası",
                    "waybill": "İrsaliye",
                    "movements": "Hareketler",
                    "delivered": "Teslim edildi",
                    "notDelivered": "Teslim edilmedi",
                    "noMovements": "Hareket bilgisi bulunmuyor",
                    "orderInfo": "Sipariş Bilgisi",
                    "notFound": "Sipariş bulunamadı",
                    "updateStatus": "Durum Güncelle",
                    "updateStatusHint": "Sipariş için yeni bir durum seçin.",
                    "statusUpdateOk": "Sipariş durumu güncellendi",
                    "trackingSaveOk": "Kargo takip numarası kaydedildi",
                    "enterNote": "Lütfen bir not girin",
                    "noteAddOk": "Not eklendi",
                    "enterValidAmount": "Geçerli bir tutar girin",
                    "collectionAddOk": "Tahsilat eklendi",
                    "usageDatesUpdateOk": "Kullanım tarihleri güncellendi",
                    "shippingFetchFail": "Kargo bilgileri alınamadı",
                    "waybillFail": "İrsaliye önizlemesi alınamadı",
                    "deleteConfirm": "Bu sipariş silinecek. Onaylıyor musunuz?"
                }
            },
            "customer": {
                "list": {
                    "cols": {
                        "customer": "Müşteri",
                        "contact": "İletişim",
                        "labels": "Etiketler",
                        "status": "Durum",
                        "date": "Kayıt Tarihi"
                    },
                    "selfLogin": "Hesabına Giriş",
                    "loginKeyReceived": "Giriş anahtarı alındı",
                    "loginStarted": "Giriş işlemi başlatıldı"
                },
                "tags": {
                    "addTitle": "Yeni Etiket",
                    "editTitle": "Etiketi Düzenle",
                    "nameLabel": "Etiket Adı",
                    "namePlaceholder": "Etiket adı",
                    "cols": {
                        "tag": "Etiket",
                        "customerCount": "Müşteri Sayısı"
                    },
                    "updateOk": "Etiket güncellendi",
                    "createOk": "Etiket eklendi"
                },
                "save": {
                    "addTitle": "Yeni Müşteri",
                    "editTitle": "Müşteriyi Düzenle",
                    "subtitle": "Müşteri bilgilerini girin ve kaydedin.",
                    "generalInformation": "Genel Bilgiler",
                    "firstname": "Ad",
                    "lastname": "Soyad",
                    "email": "E-posta",
                    "phone": "Telefon",
                    "gender": "Cinsiyet",
                    "birthDate": "Doğum Tarihi",
                    "selectDate": "Tarih seçin",
                    "idNumber": "TC Kimlik No",
                    "idNumberPlaceholder": "11 haneli",
                    "abroad": "Yurt Dışı",
                    "addresses": "Adresler",
                    "addAddress": "Adres Ekle",
                    "default": "Varsayılan",
                    "noAddress": "Kayıtlı adres yok",
                    "statusAndLabels": "Durum & Etiketler",
                    "labels": "Etiketler",
                    "changePassword": "Şifre Değiştir",
                    "password": "Şifre",
                    "newPassword": "Yeni şifre",
                    "passwordConfirm": "Şifre (Tekrar)",
                    "passwordConfirmPlaceholder": "Şifre tekrar",
                    "newPasswordConfirm": "Yeni şifre tekrar",
                    "updatePassword": "Şifreyi Güncelle",
                    "notFound": "Müşteri bulunamadı, yeni kayıt ekranına yönlendirildiniz.",
                    "updateOk": "Müşteri güncellendi",
                    "createOk": "Müşteri oluşturuldu",
                    "passwordMismatch": "Şifreler boş olmamalı ve eşleşmeli",
                    "passwordUpdateOk": "Şifre güncellendi",
                    "address": {
                        "addTitle": "Yeni Adres",
                        "editTitle": "Adresi Düzenle",
                        "title": "Adres Başlığı",
                        "titlePlaceholder": "Ev, İş…",
                        "country": "Ülke",
                        "state": "İl",
                        "city": "İlçe",
                        "district": "Mahalle/Semt",
                        "districtPlaceholder": "Mahalle",
                        "zipCode": "Posta Kodu",
                        "fullAddress": "Açık Adres",
                        "fullAddressPlaceholder": "Cadde, sokak, no…",
                        "invoiceType": "Fatura Tipi",
                        "companyName": "Firma Adı",
                        "taxOffice": "Vergi Dairesi",
                        "setDefault": "Varsayılan adres olarak ayarla",
                        "updateOk": "Adres güncellendi",
                        "createOk": "Adres eklendi"
                    }
                }
            },
            "product": {
                "list": {
                    "variantShort": "varyant",
                    "variantStockHint": "Varyantlı ürün — gösterilen stok, kombinasyon stoklarının toplamıdır.",
                    "cols": {
                        "product": "Ürün",
                        "group": "Tür",
                        "type": "Tip",
                        "price": "Fiyat",
                        "stock": "Stok",
                        "status": "Durum"
                    }
                },
                "collation": {
                    "category": {
                        "addTitle": "Kategori Ekle",
                        "editTitle": "Kategori Düzenle",
                        "generalInformation": "Genel Detaylar",
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "sort": "Sıra",
                            "status": "Durum",
                            "icon": "İkon",
                            "image": "Görsel",
                            "type": "Tür"
                        },
                        "general": "Genel",
                        "titlePlaceholder": "Kategori adı",
                        "slugPlaceholder": "kategori-slug",
                        "descriptionPlaceholder": "Kısa açıklama",
                        "settings": "Ayarlar",
                        "typeLabel": "Kategori Türü",
                        "typeSimple": "Klasik",
                        "typeDynamic": "Dinamik",
                        "typeSimpleHint": "Ürünler kategoriye elle atanır.",
                        "typeDynamicHint": "Ürünler, seçtiğiniz etiketlere göre otomatik eşlenir.",
                        "tagMatchMode": "Etiket Eşleşme Modu",
                        "tagMatchAny": "Herhangi biri (OR)",
                        "tagMatchAll": "Hepsi (AND)",
                        "tags": "Etiketler",
                        "tagsPlaceholder": "Ürün etiketleri seçin",
                        "tagsEmpty": "Etiket bulunamadı",
                        "seoSettings": "SEO Ayarları",
                        "attributeSet": "Özellik Seti",
                        "attributeSetPlaceholder": "Set seçin (opsiyonel)",
                        "attributeSetHint": "Bu kategorideki ürünler seçilen setin özel alanlarını miras alır.",
                        "seoCols": {
                            "slug": "Slug",
                            "title": "SEO Başlık",
                            "description": "SEO Açıklama",
                            "keywords": "SEO Anahtar Kelimeler"
                        }
                    },
                    "brand": {
                        "addTitle": "Marka Ekle",
                        "editTitle": "Marka Düzenle",
                        "general": "Genel",
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "image": "Görsel",
                            "sort": "Sıra",
                            "products": "Ürün"
                        },
                        "titlePlaceholder": "Marka adı",
                        "slugPlaceholder": "marka-slug",
                        "descriptionPlaceholder": "Kısa açıklama"
                    },
                    "suppliers": {
                        "addTitle": "Tedarikçi Ekle",
                        "editTitle": "Tedarikçi Düzenle",
                        "general": "Genel",
                        "contact": "İletişim",
                        "billing": "Fatura Bilgileri",
                        "cols": {
                            "name": "Ad",
                            "company": "Firma",
                            "employeeName": "Yetkili",
                            "email": "E-posta",
                            "phone": "Telefon",
                            "address": "Adres",
                            "taxNumber": "Vergi Numarası",
                            "taxOffice": "Vergi Dairesi",
                            "taxInfo": "Vergi Bilgisi",
                            "contact": "İletişim"
                        },
                        "namePlaceholder": "Tedarikçi adı",
                        "companyPlaceholder": "Firma ünvanı",
                        "employeeNamePlaceholder": "Yetkili kişi adı",
                        "addressPlaceholder": "Açık adres",
                        "taxOfficePlaceholder": "Vergi dairesi"
                    },
                    "product_units": {
                        "addTitle": "Birim Ekle",
                        "editTitle": "Birim Düzenle",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad",
                            "sort": "Sıra"
                        },
                        "namePlaceholder": "kilogram",
                        "codeHint": "Kod benzersizdir ve programatik referanslarda kullanılır; ad serbestçe değiştirilebilir."
                    },
                    "attribute": {
                        "title": "Özel Alanlar",
                        "sets": "Özellik Setleri",
                        "globalFields": "Global Alanlar",
                        "globalFieldsHint": "Her sette geçerli olan, sete bağlı olmayan ortak alanlar.",
                        "fieldsOf": "{name} — Alanlar",
                        "optionsOf": "{name} — Seçenekler",
                        "viewFields": "Alanları Görüntüle",
                        "viewOptions": "Seçenekleri Görüntüle",
                        "emptyFields": "Bu sette henüz alan tanımlı değil.",
                        "emptyOptions": "Bu alanda henüz seçenek tanımlı değil.",
                        "addSet": "Set Ekle",
                        "editSet": "Seti Düzenle",
                        "addField": "Alan Ekle",
                        "editField": "Alanı Düzenle",
                        "addOption": "Seçenek Ekle",
                        "editOption": "Seçeneği Düzenle",
                        "codeHint": "Benzersiz, programatik anahtar (a-z, 0-9, _ , -). Oluşturulduktan sonra değiştirilemez.",
                        "typeLocked": "Tip, oluşturulduktan sonra değiştirilemez.",
                        "behavior": "Davranış",
                        "validation": "Doğrulama Kuralları",
                        "optionsAfterSave": "Seçenekleri, alanı kaydettikten sonra ekleyebilirsiniz.",
                        "colorHex": "Renk Kodu",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad",
                            "description": "Açıklama",
                            "type": "Tip",
                            "unit": "Birim",
                            "flags": "Özellikler",
                            "value": "Değer",
                            "label": "Etiket",
                            "sort": "Sıra",
                            "fieldCount": "Alan"
                        },
                        "flags": {
                            "required": "Zorunlu",
                            "filterable": "Filtrelenebilir",
                            "searchable": "Aranabilir",
                            "comparable": "Karşılaştırılabilir",
                            "variant": "Varyant",
                            "visible": "Vitrinde Görünür"
                        },
                        "types": {
                            "text": "Metin",
                            "textarea": "Uzun Metin",
                            "richtext": "Zengin Metin",
                            "number": "Tam Sayı",
                            "decimal": "Ondalık",
                            "boolean": "Evet / Hayır",
                            "select": "Tekli Seçim",
                            "multiselect": "Çoklu Seçim",
                            "color": "Renk",
                            "date": "Tarih",
                            "datetime": "Tarih & Saat",
                            "url": "Bağlantı",
                            "range": "Aralık",
                            "json": "JSON"
                        }
                    },
                    "variant": {
                        "cols": {
                            "title": "Başlık",
                            "description": "Açıklama",
                            "sort": "Sıra",
                            "status": "Durum",
                            "icon": "İkon",
                            "name": "Ad",
                            "itemCount": "Öğe Sayısı",
                            "type": "Tür"
                        },
                        "typeLabel": "Görünüm Türü",
                        "typeList": "Liste",
                        "typeColor": "Renk / Görsel",
                        "typeListHint": "Öğeler düz metin liste olarak gösterilir (ör. Beden: S, M, L).",
                        "typeColorHint": "Her öğe bir renk veya görsel swatch taşır (ör. Renk: Siyah, Kırmızı).",
                        "valueLabel": "Değer (renk / görsel)",
                        "valuePlaceholder": "#000000 veya /uploads/swatch.png",
                        "valueHint": "Hex renk kodu (#1E88E5) ya da görsel yolu girin.",
                        "addTitle": "Yeni Varyant Grubu",
                        "editTitle": "Varyant Grubunu Düzenle",
                        "systemRecord": "Sistem Kaydı",
                        "systemRecordHint": "Bu kayıt sistem tarafından yönetilmekte olup düzenlenemez.",
                        "systemRecordNotSortable": "Sistem kaydı sıralanamaz",
                        "codeLabel": "Kod",
                        "nameLabel": "Ad",
                        "namePlaceholder": "Varyant grup adı",
                        "productGroups": "Ürün Grupları",
                        "items": "Öğeler",
                        "addItem": "Öğe Ekle",
                        "addItemTitle": "Yeni öğe ekle",
                        "saveGroupFirst": "Önce grubu kaydedin",
                        "reorderHint": "Öğeleri yeniden sıralamak için sürükleyip bırakın",
                        "dragToSort": "Sürükleyerek sırala",
                        "noItems": "Henüz öğe eklenmemiş",
                        "noItemsHint": "Bu varyant grubuna ilk öğeyi ekleyin.",
                        "editItemTitle": "Öğeyi Düzenle",
                        "newItemTitle": "Yeni Öğe",
                        "itemNamePlaceholder": "Örn. Siyah, Large, 42",
                        "saveGroupBeforeItem": "Öğe eklemeden önce varyant grubunu kaydedin",
                        "itemUpdateOk": "Öğe güncellendi",
                        "itemCreateOk": "Öğe eklendi",
                        "itemTitleRequired": "Lütfen tüm öğe başlıklarını doldurun",
                        "itemSaveFail": "Öğeler kaydedilirken bir hata oluştu",
                        "reorderPartialFail": "Bazı öğeler sıralanamadı, liste yenileniyor",
                        "reorderOk": "Sıralama güncellendi",
                        "reorderFail": "Sıralama kaydedilemedi"
                    },
                    "productGroups": {
                        "optionGroups": "Seçenek Grupları",
                        "variantGroups": "Varyant Grupları",
                        "detailGroups": "Detay Grupları",
                        "notDefined": "Tanımlı değil",
                        "addTitle": "Yeni Ürün Grubu",
                        "editTitle": "Ürün Grubunu Düzenle",
                        "codeLabel": "Kod",
                        "nameLabel": "Ad",
                        "namePlaceholder": "Ürün grup adı",
                        "supportedGroups": "Desteklenen Gruplar",
                        "optionGroupPlaceholder": "Seçenek grubu seçin",
                        "variantGroupPlaceholder": "Varyant grubu seçin",
                        "detailGroupPlaceholder": "Detay grubu seçin",
                        "modules": "Modüller",
                        "modulePlaceholder": "Modül seçin",
                        "cols": {
                            "code": "Kod",
                            "name": "Ad"
                        }
                    }
                },
                "save": {
                    "addTitle": "Yeni Ürün",
                    "editTitle": "Ürünü Düzenle",
                    "subtitle": "Ürün bilgilerini girin ve kaydedin.",
                    "generalInformation": "Genel Bilgiler",
                    "productGroup": "Ürün Grubu",
                    "groupLocked": "Ürün grubu oluşturulduktan sonra değiştirilemez.",
                    "productType": "Ürün Tipi",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Ürün başlığı",
                    "categories": "Kategoriler",
                    "taxes": "Vergiler",
                    "brand": "Marka",
                    "attributeSet": "Özellik Seti",
                    "attributeSetInherit": "Kategoriden miras al",
                    "attributeSetHint": "Boş bırakılırsa kategorinin seti kullanılır.",
                    "shortDescription": "Kısa Açıklama",
                    "shortDescriptionPlaceholder": "Liste ve kartlarda görünen kısa açıklama",
                    "showInList": "Listede Göster",
                    "showInListHint": "Ürün listelerinde görünsün.",
                    "showInPopular": "Popülerlerde Göster",
                    "showInPopularHint": "Popüler ürünler bölümünde görünsün.",
                    "priceRequired": "En az bir fiyat girmelisiniz.",
                    "tags": "Etiketler",
                    "tagsPlaceholder": "Etiket yazıp Enter'a basın",
                    "sort": "Sıra",
                    "mainImage": "Ana Görsel",
                    "content": "İçerik",
                    "contentPlaceholder": "Ürün açıklaması",
                    "pricing": "Fiyatlandırma",
                    "addPrice": "Fiyat Ekle",
                    "price": "Fiyat",
                    "discounted": "İndirimli",
                    "datesAndStock": "Tarihler & Stok",
                    "saleStart": "Satış Başlangıç",
                    "saleEnd": "Satış Bitiş",
                    "usageStart": "Kullanım Başlangıç",
                    "usageEnd": "Kullanım Bitiş",
                    "selectDate": "Tarih seçin",
                    "maxUsageDay": "Maks. Kullanım (Gün)",
                    "stock": "Stok",
                    "trackStock": "Stok Takibi",
                    "trackStockHint": "Kapalıysa ürün stok kontrolüne tabi olmaz (sanal ürünler).",
                    "currentStock": "Mevcut Stok",
                    "variantStockNote": "kombinasyon toplamı",
                    "errTitleRequired": "Ürün başlığı zorunludur.",
                    "errContentRequired": "Ürün içeriği (açıklama) zorunludur.",
                    "errPriceRequired": "En az bir geçerli fiyat girin (para birimi + tutar).",
                    "langSelectHint": "Çeviri alanları (başlık, içerik, SEO) seçili dile göre düzenlenir.",
                    "viewOnSite": "Ürünü sitede görüntüle",
                    "stockMovements": "Stok hareketleri",
                    "initialWarehouse": "Açılış Deposu",
                    "initialStock": "Açılış Stoğu",
                    "stockCode": "Stok Kodu",
                    "shippingWeight": "Kargo Ağırlığı (kg)",
                    "shipping": "Kargo",
                    "keywords": "Anahtar Kelimeler",
                    "keywordsPlaceholder": "kelime1, kelime2",
                    "metaTitlePlaceholder": "Meta başlık",
                    "metaDescPlaceholder": "Meta açıklama",
                    "googlePreview": "Google Önizleme",
                    "previewHint": "Başlık ~60, açıklama ~160 karakterde kesilir. Önizleme temsilidir.",
                    "yourStore": "Mağazanız",
                    "previewDescFallback": "Bu ürün için bir açıklama girildiğinde burada görünecektir.",
                    "notFound": "Ürün bulunamadı, yeni ürün ekleme ekranına yönlendirildiniz."
                }
            },
            "discount": {
                "couponCodes": {
                    "addTitle": "Yeni Kupon",
                    "editTitle": "Kuponu Düzenle",
                    "generalInfo": "Kupon Bilgileri",
                    "type": "Oluşturma Tipi",
                    "typeSingle": "Tekli",
                    "typeMulti": "Toplu",
                    "typeMultiHint": "Toplu üretimde kodlar otomatik üretilir ve Excel olarak indirilir.",
                    "codeLabel": "Kupon Kodu",
                    "codePlaceholder": "Örn. WELCOME10",
                    "generate": "Kod Üret",
                    "count": "Adet",
                    "countPlaceholder": "Örn. 100",
                    "discountType": "İndirim Tipi",
                    "discountStatic": "Sabit (₺)",
                    "discountPercent": "Yüzdesel (%)",
                    "discountValue": "İndirim Değeri",
                    "minAmount": "Minimum Sepet Tutarı",
                    "limits": "Kullanım Limitleri",
                    "totalUseLimit": "Toplam Kullanım Limiti",
                    "userUseLimit": "Kullanıcı Başına Limit",
                    "unlimitedHint": "Boş bırakılırsa sınırsız.",
                    "cannotCombined": "Diğer kuponlarla birleştirilemez",
                    "dates": "Geçerlilik Tarihleri",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "immutableHint": "Kod, indirim tipi ve değeri oluşturulduktan sonra değiştirilemez.",
                    "createOk": "Kupon oluşturuldu",
                    "multiCreateOk": "Kuponlar oluşturuldu ve Excel indirildi",
                    "updateOk": "Kupon güncellendi",
                    "unlimited": "Sınırsız",
                    "cols": {
                        "code": "Kod",
                        "type": "Tip",
                        "value": "Değer",
                        "used": "Kullanım",
                        "dates": "Tarihler"
                    }
                }
            }
        },
        "site": {
            "content": {
                "themes": {
                    "loading": "Yükleniyor…",
                    "notFound": "Tema bulunamadı.",
                    "activate": "Aktif Et",
                    "activating": "Etkinleştiriliyor…",
                    "activateSuccess": "Tema aktif edildi",
                    "actionFailed": "İşlem başarısız",
                    "customizeTheme": "Temayı Özelleştir",
                    "settingsButton": "Ayarlar",
                    "allThemes": "Tüm Temalar",
                    "activeTheme": "Aktif Tema",
                    "intro": {
                        "around": "Around, modern ve çok amaçlı bir e-ticaret temasıdır. Geniş bileşen kütüphanesi, hızlı yüklenen sayfaları ve mobil uyumlu tasarımıyla mağazanıza şık ve profesyonel bir görünüm kazandırır."
                    },
                    "settings": {
                        "title": "Tema Ayarları",
                        "description": "Temanın renk ve görünüm ayarlarını yapılandırın.",
                        "theme": "Tema",
                        "empty": "Bu tema için ayar bulunmuyor."
                    }
                },
                "themeBuilder": {
                    "title": "Sayfa Düzenleyici",
                    "description": "Sayfa seçip bileşenleri sürükle-bırak ile düzenleyin, önizleyin ve yayınlayın.",
                    "pages": "Sayfalar",
                    "pagesHint": "Düzenlemek için bir sayfa seçin.",
                    "noPages": "Özelleştirilebilir sayfa yok.",
                    "blocks": "Bileşenler",
                    "backToPages": "Sayfalara dön",
                    "addComponent": "Bileşen Ekle",
                    "addToZone": "Bu alana bileşen ekle",
                    "palette": "Bileşen Paleti",
                    "paletteHint": "Eklemek için bir bileşene tıklayın.",
                    "noComponents": "Bu alan için uygun bileşen yok.",
                    "emptyZone": "Bu alan boş — aşağıdan bileşen ekleyin.",
                    "editBlock": "Bileşeni Düzenle",
                    "blockSettings": "Bileşen Ayarları",
                    "language": "Dil",
                    "spacing": "Boşluk (px)",
                    "spacingPt": "Üst iç boşluk",
                    "spacingPb": "Alt iç boşluk",
                    "spacingMt": "Üst dış boşluk",
                    "spacingMb": "Alt dış boşluk",
                    "duplicate": "Çoğalt",
                    "remove": "Kaldır",
                    "removeBlockConfirm": "Bu bileşen kaldırılsın mı?",
                    "status": "Durum",
                    "draft": "Taslak",
                    "published": "Yayınlanan",
                    "saveDraft": "Taslağı Kaydet",
                    "saving": "Kaydediliyor…",
                    "autoSaved": "Kaydedildi",
                    "autoSavePending": "Bekliyor…",
                    "publish": "Yayınla",
                    "publishing": "Yayınlanıyor…",
                    "publishConfirm": "Taslak yayınlansın mı? Mevcut yayınlanan içerik değişecek.",
                    "preview": "Önizleme",
                    "deviceDesktop": "Masaüstü",
                    "deviceTablet": "Tablet",
                    "deviceMobile": "Mobil",
                    "goToSite": "Siteye git",
                    "openInNewTab": "Taslağı yeni sekmede aç",
                    "refreshPreview": "Önizlemeyi yenile",
                    "previewPlaceholder": "Önizleme için bir sayfa seçin.",
                    "previewLoading": "Önizleme oluşturuluyor…",
                    "previewEmpty": "Önizlenecek bileşen yok.",
                    "previewUnavailable": "Önizleme şu an kullanılamıyor.",
                    "relationId": "İlişki Kaydı",
                    "relationDefault": "Tüm kategoriler (varsayılan)",
                    "relationDefaultProduct": "Tüm ürünler (varsayılan) · ürün ara veya id gir",
                    "relationDefaultBlog": "Tüm blog yazıları (varsayılan) · ara veya id gir",
                    "relationDefaultPage": "Tüm sayfalar (varsayılan) · ara veya id gir",
                    "relationScopeDefault": "Varsayılan düzen düzenleniyor — tüm kayıtlar için geçerli.",
                    "relationScopeOverride": "Bu kayda özel düzen düzenleniyor (varsayılanı geçersiz kılar).",
                    "unsavedChanges": "Kaydedilmemiş değişiklikler var.",
                    "loadFailed": "Sayfa düzeni yüklenemedi.",
                    "saveOk": "Taslak kaydedildi.",
                    "saveFailed": "Taslak kaydedilemedi.",
                    "publishOk": "Sayfa yayınlandı.",
                    "publishFailed": "Yayınlanamadı.",
                    "category": "Kategori"
                },
                "slider": {
                    "addTitle": "Yeni Slider Grubu",
                    "editTitle": "Slider Grubunu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "aliasLabel": "Takma Ad (alias)",
                    "actions": {
                        "slides": "Slaytlar"
                    },
                    "cols": {
                        "alias": "Takma Ad",
                        "itemsCount": "Slayt Sayısı"
                    },
                    "items": {
                        "title": "Slaytlar",
                        "subtitle": "Grup #{id} slayt içeriklerini yönetin.",
                        "buttons": "Butonlar",
                        "addTitle": "Yeni Slayt",
                        "editTitle": "Slaytı Düzenle",
                        "content": "İçerik",
                        "titleLabel": "Başlık",
                        "titlePlaceholder": "Slayt başlığı",
                        "shortTitle": "Kısa Başlık",
                        "shortTitlePlaceholder": "Kısa başlık",
                        "description": "Açıklama",
                        "link": "Bağlantı (slug)",
                        "imageSettings": "Görsel & Ayarlar",
                        "scheduleSettings": "Zamanlama & Görünürlük",
                        "image": "Görsel",
                        "imagePerLangHint": "Her dil için ayrı görsel seçebilirsiniz. Boş bırakılırsa diğer dilin görseli kullanılır.",
                        "imageRequired": "Ana dil için görsel seçilmelidir.",
                        "startDate": "Başlangıç Tarihi",
                        "endDate": "Bitiş Tarihi",
                        "datePlaceholder": "Tarih seçin",
                        "sort": "Sıra",
                        "slideButtons": "Slayt Butonları",
                        "editButton": "Butonu Düzenle",
                        "newButton": "Yeni Buton",
                        "buttonText": "Buton metni",
                        "icon": "İkon",
                        "definedButtons": "Tanımlı Butonlar",
                        "loading": "Yükleniyor…",
                        "noButtons": "Henüz buton eklenmemiş.",
                        "cols": {
                            "image": "Görsel",
                            "title": "Başlık",
                            "dates": "Tarihler",
                            "sort": "Sıra",
                            "buttons": "Butonlar"
                        }
                    }
                },
                "seo": {
                    "title": "SEO",
                    "metaTitle": "Meta Başlık",
                    "metaTitlePlaceholder": "Meta başlık",
                    "metaDescription": "Meta Açıklama",
                    "metaDescriptionPlaceholder": "Meta açıklama",
                    "metaKeywords": "Meta Anahtar Kelimeler",
                    "metaKeywordsPlaceholder": "virgülle ayrılmış"
                },
                "blogCategories": {
                    "title": "Blog Kategorileri",
                    "subtitle": "Blog kategorilerini oluşturun ve yönetin.",
                    "addTitle": "Yeni Kategori",
                    "editTitle": "Kategoriyi Düzenle",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Kategori adı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Kategoriler",
                    "cols": {
                        "title": "Başlık",
                        "postsCount": "Yazı Sayısı"
                    }
                },
                "blog": {
                    "addTitle": "Yeni Blog Yazısı",
                    "editTitle": "Blog Yazısını Düzenle",
                    "content": "İçerik",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Blog başlığı",
                    "slug": "Slug",
                    "categories": "Kategoriler",
                    "selectCategory": "Kategori seçin",
                    "image": "Görsel",
                    "summary": "Özet",
                    "summaryPlaceholder": "Kısa açıklama",
                    "contentPlaceholder": "Blog içeriği",
                    "sort": "Sıra",
                    "cols": {
                        "image": "Görsel",
                        "title": "Başlık",
                        "categories": "Kategoriler"
                    }
                },
                "pages": {
                    "addTitle": "Yeni Sayfa",
                    "editTitle": "Sayfayı Düzenle",
                    "content": "İçerik",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Sayfa başlığı",
                    "slug": "Slug",
                    "image": "Kapak Görseli",
                    "contentPlaceholder": "Sayfa içeriği (HTML)",
                    "sort": "Sıra",
                    "pageWidth": "Sayfa Genişliği",
                    "widths": {
                        "normal": "Normal",
                        "large": "Geniş",
                        "full": "Tam Genişlik"
                    },
                    "cols": {
                        "title": "Başlık",
                        "slug": "Slug"
                    }
                },
                "faq": {
                    "categoriesAction": "Kategoriler",
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "code": "Kod",
                    "name": "Ad",
                    "namePlaceholder": "Örn. Genel Sorular",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "questionsCount": "Soru Sayısı"
                    }
                },
                "faqCategories": {
                    "title": "SSS Kategorileri",
                    "subtitle": "Grup #{id} kategorilerini yönetin.",
                    "questionsAction": "Sorular",
                    "addTitle": "Yeni Kategori",
                    "editTitle": "Kategoriyi Düzenle",
                    "categoryInfo": "Kategori Bilgileri",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Kategori adı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Kategoriler",
                    "cols": {
                        "title": "Başlık",
                        "questionsCount": "Soru Sayısı"
                    }
                },
                "faqQuestions": {
                    "title": "Sorular",
                    "subtitle": "Kategori #{id} sorularını yönetin.",
                    "addTitle": "Yeni Soru",
                    "editTitle": "Soruyu Düzenle",
                    "questionAnswer": "Soru & Cevap",
                    "question": "Soru",
                    "questionPlaceholder": "Soru metni",
                    "answer": "Cevap",
                    "answerPlaceholder": "Cevap metni",
                    "sort": "Sıra",
                    "cols": {
                        "question": "Soru",
                        "answer": "Cevap",
                        "sort": "Sıra"
                    }
                },
                "featuredProducts": {
                    "productsAction": "Ürünler",
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "name": "Ad",
                    "namePlaceholder": "Örn. IELTS",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Vitrin başlığı",
                    "description": "Açıklama",
                    "sort": "Sıra",
                    "cols": {
                        "name": "Ad",
                        "title": "Başlık",
                        "productsCount": "Ürün Sayısı"
                    }
                },
                "featuredProductsItems": {
                    "title": "Öne Çıkan Ürünler",
                    "subtitle": "Grup #{id} için öne çıkan ürünleri yönetin.",
                    "addTitle": "Yeni Öne Çıkan Ürün",
                    "editTitle": "Öne Çıkan Ürünü Düzenle",
                    "productInfo": "Ürün Bilgileri",
                    "product": "Ürün",
                    "selectProduct": "Ürün seçin",
                    "productLocked": "Ürün, oluşturulduktan sonra değiştirilemez.",
                    "tag": "Etiket (watch_tag)",
                    "tagPlaceholder": "Örn. Online",
                    "description": "Açıklama",
                    "descriptionPlaceholder": "İsteğe bağlı açıklama",
                    "sort": "Sıra",
                    "breadcrumb": "Ürünler",
                    "cols": {
                        "product": "Ürün",
                        "tag": "Etiket",
                        "sort": "Sıra"
                    }
                },
                "forms": {
                    "elementsAction": "Alanlar",
                    "answersAction": "Yanıtlar",
                    "addTitle": "Yeni Form",
                    "editTitle": "Formu Düzenle",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Form başlığı",
                    "slug": "Slug",
                    "description": "Açıklama",
                    "image": "Görsel",
                    "redirectUrl": "Yanıt sonrası yönlendirme URL",
                    "redirectUrlPlaceholder": "https://... (opsiyonel)",
                    "cols": {
                        "title": "Başlık",
                        "manage": "Yönetim"
                    }
                },
                "formElements": {
                    "title": "Form Alanları",
                    "subtitle": "Form #{id} alanlarını yönetin.",
                    "addTitle": "Yeni Alan",
                    "editTitle": "Alanı Düzenle",
                    "fieldInfo": "Alan Bilgileri",
                    "fieldType": "Alan Tipi",
                    "selectType": "Tip seçin",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Örn. Adınız Soyadınız",
                    "description": "Açıklama",
                    "helpText": "Yardım metni",
                    "placeholder": "Placeholder",
                    "placeholderHint": "İpucu metni",
                    "sort": "Sıra",
                    "advanced": "Gelişmiş",
                    "advancedHint": "Doğrulama/seçenekler JSON formatında. Örn. doğrulama:",
                    "validationOptions": "Doğrulama / Seçenekler (options)",
                    "itemsLabel": "Öğeler (items) — seçim tipleri için",
                    "itemsPlaceholder": "[\"Seçenek 1\",\"Seçenek 2\"]",
                    "breadcrumb": "Alanlar",
                    "invalidJson": "options / items alanı geçerli JSON olmalı",
                    "cols": {
                        "type": "Tip",
                        "title": "Başlık",
                        "sort": "Sıra"
                    }
                },
                "formAnswers": {
                    "title": "Form Yanıtları",
                    "subtitle": "Form #{id} yanıtlarını görüntüleyin.",
                    "view": "Görüntüle",
                    "answerDetail": "Yanıt Detayı",
                    "loading": "Yükleniyor…",
                    "ip": "IP",
                    "dateLabel": "Tarih",
                    "browser": "Tarayıcı",
                    "answers": "Cevaplar",
                    "noAnswers": "Cevap yok.",
                    "breadcrumb": "Yanıtlar",
                    "exportFailed": "Dışa aktarma başarısız",
                    "cols": {
                        "ip": "IP",
                        "answersCount": "Cevap Sayısı",
                        "date": "Tarih"
                    }
                },
                "links": {
                    "hiddenInSearch": "Aramada gizli",
                    "hiddenInSitemap": "Site haritasında gizli",
                    "addTitle": "Yeni Yönlendirme",
                    "editTitle": "Linki Düzenle",
                    "link": "Bağlantı",
                    "content": "İçerik",
                    "redirectType": "Yönlendirme Türü",
                    "permanentRedirect": "Kalıcı Yönlendirme (301)",
                    "temporaryRedirect": "Geçici Yönlendirme (302)",
                    "slug": "Slug",
                    "redirect": "Yönlendirme (redirect)",
                    "targetSlug": "hedef-baglanti",
                    "targetSlugOptional": "hedef-baglanti (opsiyonel)",
                    "redirectHint": "Bu slug, hedef slug'a yönlendirilir.",
                    "searchEngine": "Arama Motoru",
                    "hideInSearch": "Aramada gizle (noindex)",
                    "hideInSitemap": "Site haritasında gizle",
                    "cols": {
                        "language": "Dil",
                        "type": "Tür",
                        "content": "İçerik",
                        "slug": "Slug",
                        "redirect": "Yönlendirme",
                        "flags": "Bayraklar"
                    }
                },
                "menus": {
                    "addTitle": "Yeni Menü",
                    "editTitle": "Menüyü Düzenle",
                    "namePlaceholder": "Örn. Ana Menü (Header)",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez (HEADER/FOOTER bileşeni bu kodu kullanır).",
                    "editItems": "Öğeleri düzenle",
                    "builderTitle": "Menü Düzenleyici",
                    "builderHint": "Öğeleri sürükleyerek sıralayın; alt seviyelere taşıyarak dropdown/mega yapısı kurun.",
                    "addItem": "Öğe Ekle",
                    "newItem": "Yeni Öğe",
                    "editItem": "Öğeyi Düzenle",
                    "empty": "Bu menüde henüz öğe yok",
                    "emptyHint": "İlk öğeyi ekleyin; link, dropdown veya mega menü olarak kurgulayabilirsiniz.",
                    "savingOrder": "Sıralama kaydediliyor…",
                    "titlePlaceholder": "Örn. Anasayfa",
                    "titleRequired": "En az bir dilde başlık girin.",
                    "perLanguage": "Dile Göre İçerik",
                    "urlHint": "Bağlantı adresi. Örn. /, /kampanya, https://...",
                    "urlContainerHint": "Kapsayıcı öğeler (dropdown/mega/kolon) için genelde boş bırakılır (# olur).",
                    "deleteConfirm": "Bu öğe ve tüm alt öğeleri silinecek. Emin misiniz?",
                    "types": {
                        "LINK": "Link",
                        "DROPDOWN": "Açılır Menü (Dropdown)",
                        "MEGA": "Mega Menü",
                        "COLUMN": "Kolon",
                        "PRODUCTS": "Ürün Kartları"
                    },
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "items": "Öğe Sayısı",
                        "type": "Tip",
                        "title": "Başlık",
                        "url": "URL",
                        "columns": "Kolon Sayısı"
                    }
                },
                "popup": {
                    "buttonsAction": "Butonlar",
                    "addTitle": "Yeni Popup",
                    "editTitle": "Popup Düzenle",
                    "drawerSubtitle": "Görünüm, zamanlama ve hedefleme ayarları",
                    "general": "Genel",
                    "titleLabel": "Başlık",
                    "titlePlaceholder": "Popup başlığı",
                    "contentLabel": "İçerik",
                    "contentPlaceholder": "Popup içeriği",
                    "scheduling": "Zamanlama",
                    "startDate": "Başlangıç Tarihi",
                    "endDate": "Bitiş Tarihi",
                    "datePlaceholder": "Tarih seçin",
                    "displaySettings": "Görüntüleme Ayarları",
                    "popupType": "Popup Tipi",
                    "typeContent": "İçerik",
                    "typeImage": "Görsel",
                    "repeatDays": "Tekrar (gün)",
                    "delaySeconds": "Gecikme (sn)",
                    "sticky": "Yapışkan",
                    "stickyDuration": "Yapışkan süresi (sn)",
                    "dontShowAgain": "\"Bir daha gösterme\"",
                    "hideHeader": "Başlığı gizle",
                    "hideFooter": "Alt bilgiyi gizle",
                    "sort": "Sıra",
                    "visibility": "Görünürlük (Sayfa Hedefleme)",
                    "visibilityHint": "Gösterilecek doluysa yalnızca o sayfalarda çıkar; boş + gizlenecek doluysa onlar hariç her yerde; ikisi de boşsa her yerde.",
                    "routeSection": "Sayfalar",
                    "userLabelSection": "Kullanıcı Etiketleri",
                    "pagesToShow": "Gösterilecek sayfalar",
                    "pagesToHide": "Gizlenecek sayfalar",
                    "labelsToShow": "Gösterilecek etiketler",
                    "labelsToHide": "Gizlenecek etiketler",
                    "noRule": "Kural yok.",
                    "noRuleShow": "Kural yok (her yerde gösterilir).",
                    "noRuleHide": "Kural yok.",
                    "allHint": "type_id: belirli bir kaydın ID'si; -1 = bu tipteki tüm sayfalar.",
                    "type": "Tip",
                    "popupButtons": "Popup Butonları",
                    "editButton": "Butonu Düzenle",
                    "newButton": "Yeni Buton",
                    "buttonText": "Buton metni",
                    "link": "Bağlantı (slug)",
                    "definedButtons": "Tanımlı Butonlar",
                    "loading": "Yükleniyor…",
                    "noButtons": "Henüz buton eklenmemiş.",
                    "cols": {
                        "title": "Başlık",
                        "dates": "Tarihler",
                        "buttons": "Butonlar"
                    }
                }
            },
            "administrators": {
                "admins": {
                    "addTitle": "Yeni Yönetici",
                    "editTitle": "Yöneticiyi Düzenle",
                    "accountInfo": "Hesap Bilgileri",
                    "selectGroup": "Grup seçin",
                    "currentPassword": "Mevcut Şifre",
                    "ifRequired": "(gerekiyorsa)",
                    "newPassword": "Yeni Şifre",
                    "newPasswordConfirm": "Yeni Şifre (Tekrar)",
                    "newPasswordConfirmPlaceholder": "Yeni şifre tekrar",
                    "cols": {
                        "firstname": "Ad",
                        "lastname": "Soyad",
                        "fullname": "Ad Soyad",
                        "email": "E-Posta",
                        "group": "Grup",
                        "password": "Şifre"
                    }
                },
                "groups": {
                    "addTitle": "Yeni Grup",
                    "editTitle": "Grubu Düzenle",
                    "groupInfo": "Grup Bilgileri",
                    "permissions": "İzinler",
                    "duplicate": "Çoğalt",
                    "duplicateConfirm": "\"{name}\" grubunu çoğaltmak istiyor musunuz?",
                    "duplicateSuccess": "Grup çoğaltıldı",
                    "namePlaceholder": "Örn. Editör",
                    "optionalPlaceholder": "(opsiyonel)",
                    "cols": {
                        "name": "Ad",
                        "code": "Kod",
                        "users": "Kullanıcı"
                    }
                },
                "permissions": {
                    "title": "İzin Yönetimi",
                    "groupPermissions": "{name} grubu izinleri",
                    "groupNumber": "Grup #{id}",
                    "endpointPermissions": "Endpoint İzinleri",
                    "searchPlaceholder": "Ara…",
                    "loading": "Yükleniyor…",
                    "notFound": "Endpoint bulunamadı.",
                    "endpoint": "Endpoint",
                    "otherGroup": "Diğer",
                    "saveFailed": "Kaydedilemedi",
                    "selectAllGroup": "Tüm grubu seç / kaldır"
                }
            },
            "localization": {
                "currencies": {
                    "addTitle": "Yeni Para Birimi",
                    "editTitle": "Para Birimini Düzenle",
                    "currencyInfo": "Para Birimi Bilgileri",
                    "prefix": "Ön Ek (prefix)",
                    "suffix": "Son Ek (suffix)",
                    "commissionRate": "Komisyon / Kur",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "symbol": "Sembol",
                        "commission": "Komisyon"
                    }
                },
                "languages": {
                    "addTitle": "Yeni Dil",
                    "editTitle": "Dili Düzenle",
                    "languageInfo": "Dil Bilgileri",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad"
                    }
                },
                "taxes": {
                    "addTitle": "Yeni Vergi",
                    "editTitle": "Vergiyi Düzenle",
                    "taxInfo": "Vergi Bilgileri",
                    "selectCountry": "Ülke seçin",
                    "ratePercent": "Oran (%)",
                    "sort": "Sıra",
                    "cols": {
                        "country": "Ülke",
                        "code": "Kod",
                        "name": "Ad",
                        "rate": "Oran"
                    }
                },
                "countries": {
                    "title": "Ülkeler",
                    "states": "İller",
                    "cities": "İlçeler",
                    "searchCountry": "Ülke ara...",
                    "searchState": "İl ara...",
                    "searchCity": "İlçe ara...",
                    "viewStates": "İlleri görüntüle",
                    "viewCities": "İlçeleri görüntüle",
                    "statesOf": "{name} illeri",
                    "citiesOf": "{name} ilçeleri",
                    "addCountry": "Yeni Ülke",
                    "editCountry": "Ülkeyi Düzenle",
                    "addState": "Yeni İl",
                    "editState": "İli Düzenle",
                    "addCity": "Yeni İlçe",
                    "editCity": "İlçeyi Düzenle",
                    "countryInfo": "Ülke Bilgileri",
                    "stateInfo": "İl Bilgileri",
                    "cityInfo": "İlçe Bilgileri",
                    "emptyStates": "Bu ülkeye ait il bulunmuyor.",
                    "emptyCities": "Bu ile ait ilçe bulunmuyor.",
                    "cols": {
                        "id": "ID",
                        "name": "Ad",
                        "isoCode2": "ISO Kodu (2)",
                        "isoCode3": "ISO Kodu (3)",
                        "currency": "Para Birimi",
                        "stateCount": "İl Sayısı"
                    }
                }
            },
            "settings": {
                "mediaProviders": {
                    "addTitle": "Yeni Sağlayıcı",
                    "editTitle": "Sağlayıcıyı Düzenle",
                    "providerInfo": "Sağlayıcı Bilgileri",
                    "accounts": "Hesaplar",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez.",
                    "namePlaceholder": "Örn. Vimeo",
                    "cols": {
                        "code": "Kod",
                        "name": "Ad",
                        "platforms": "Platformlar",
                        "accountsCount": "Hesap Sayısı"
                    }
                },
                "mediaProvider": {
                    "description": "Sağlayıcı hesaplarını ve kimlik bilgilerini yönetin.",
                    "providers": "Sağlayıcılar",
                    "accounts": "Hesaplar",
                    "addTitle": "Yeni Hesap",
                    "editTitle": "Hesabı Düzenle",
                    "accountInfo": "Hesap Bilgileri",
                    "titlePlaceholder": "Örn. Ana Hesap",
                    "credentials": "Kimlik Bilgileri",
                    "credentialsHint": "Güvenlik için mevcut değerler gösterilmez. Değiştirmek istemiyorsanız boş bırakın.",
                    "noCredentialFields": "Bu sağlayıcı için tanımlı kimlik bilgisi alanı bulunmuyor.",
                    "cols": {
                        "title": "Başlık"
                    }
                },
                "siteSetting": {
                    "title": "Site & Anasayfa Ayarları",
                    "empty": "Tanımlı ayar alanı bulunmuyor."
                },
                "systemSetting": {
                    "title": "Kayıt Ayarları",
                    "empty": "Tanımlı ayar alanı bulunmuyor."
                },
                "registerElements": {
                    "title": "Kayıt Formu Alanları",
                    "addTitle": "Yeni Alan",
                    "editTitle": "Alanı Düzenle",
                    "nameLabel": "Alan Adı (name)",
                    "nameHint": "Formdaki alanın anahtar adı (ör. tax_number, phone). Oluşturduktan sonra değiştirilemez.",
                    "optionsTitle": "Seçenekler",
                    "inputType": "Girdi Tipi",
                    "required": "Zorunlu alan",
                    "multiple": "Çoklu seçim",
                    "items": "Seçenekler",
                    "itemText": "Etiket",
                    "itemValue": "Değer (opsiyonel)",
                    "addItem": "Seçenek ekle",
                    "itemsRequired": "Bu alan tipi için en az bir seçenek girilmelidir.",
                    "inputTypes": {
                        "text": "Metin",
                        "email": "E-posta",
                        "password": "Parola",
                        "number": "Sayı",
                        "tel": "Telefon",
                        "url": "URL",
                        "radio": "Tekli seçim (radio)",
                        "checkbox": "Onay kutusu"
                    },
                    "typeNames": {
                        "input": "Girdi",
                        "textarea": "Uzun Metin",
                        "select": "Açılır Menü",
                        "radio_group": "Radyo Grubu",
                        "checkbox_group": "Onay Kutusu Grubu",
                        "state": "İl",
                        "city": "İlçe"
                    }
                },
                "systemVariables": {
                    "addTitle": "Yeni Değişken",
                    "editTitle": "Değişkeni Düzenle",
                    "variable": "Değişken",
                    "codeImmutable": "Kod oluşturulduktan sonra değiştirilemez.",
                    "descriptionPlaceholder": "Opsiyonel açıklama",
                    "cols": {
                        "code": "Kod",
                        "value": "Değer",
                        "description": "Açıklama"
                    }
                },
                "trackingCodes": {
                    "addTitle": "Yeni İzleme Kodu",
                    "editTitle": "İzleme Kodunu Düzenle",
                    "codeInfo": "Kod Bilgileri",
                    "namePlaceholder": "Örn. Google Analytics",
                    "selectLocation": "Konum seçin",
                    "contentLabel": "İçerik (kod)",
                    "visibility": "Görünürlük (Sayfa Hedefleme)",
                    "visibilityHint": "ID için: <b>0</b> kök, <b>-1</b> ilgili tipin tümü. Boş bırakılırsa her yerde çalışır.",
                    "toShow": "Gösterilecek",
                    "toHide": "Gizlenecek",
                    "type": "Tip",
                    "cols": {
                        "name": "Ad",
                        "location": "Konum",
                        "sort": "Sıra"
                    }
                }
            }
        },
        "library": {
            "liveDataWarning": "Canlı veride işlem yapmaktasınız. Lütfen bir değişiklik yaparken dikkatli olunuz.",
            "action": {
                "selectAll": "Hepsini seç",
                "deselectAll": "Tüm seçimi kaldır"
            },
            "menu": {
                "favorites": "Favoriler",
                "trash": "Çöp Kutusu"
            }
        },
        "campaignsPage": {
            "drawer": {
                "editTitle": "Kampanyayı Düzenle",
                "createTitle": "Kampanya Oluştur"
            },
            "sections": {
                "info": "Kampanya Bilgileri",
                "discount": "İndirim",
                "buyXPayY": "X Al Y Öde",
                "targeting": "Hangi Ürünlerde Geçerli",
                "conditions": "Koşullar",
                "validityPriority": "Geçerlilik & Öncelik"
            },
            "labels": {
                "name": "Kampanya Adı",
                "type": "Kampanya Türü",
                "discountType": "İndirim Tipi",
                "discountValue": "İndirim Değeri",
                "maxDiscount": "Maksimum İndirim",
                "buyQuantity": "Alınan Adet (X)",
                "payQuantity": "Ödenen Adet (Y)",
                "minAmount": "Minimum Sepet Tutarı",
                "minQuantity": "Minimum Ürün Adedi",
                "startDate": "Başlangıç Tarihi",
                "endDate": "Bitiş Tarihi",
                "priority": "Öncelik",
                "salesChannel": "Satış Kanalı",
                "cannotCombined": "Diğer kampanyalarla birleştirilemez"
            },
            "types": {
                "cartDiscount": "Sepet İndirimi",
                "productDiscount": "Ürün İndirimi",
                "buyXPayY": "X Al Y Öde",
                "freeShipping": "Bedava Kargo"
            },
            "discountTypes": {
                "fixed": "Sabit Tutar",
                "percent": "Yüzde"
            },
            "targetModes": {
                "products": "Ürünler",
                "categories": "Kategori",
                "brands": "Marka",
                "tags": "Etiket"
            },
            "placeholders": {
                "name": "Örn. Yaz İndirimi",
                "maxDiscount": "Sınırsız",
                "searchProduct": "Ürün adı ile ara…",
                "selectCategory": "Kategori seçin",
                "selectBrand": "Marka seçin",
                "selectTag": "Etiket seçin",
                "none": "Yok",
                "selectDate": "Tarih seçin",
                "allChannels": "Tüm kanallar"
            },
            "hints": {
                "buyXPayY": "Örn. 3 Al 2 Öde → en ucuz 1 ürün bedava. Eşleşen ürünler aşağıdaki hedeflemeden alınır.",
                "targeting": "Boş bırakılırsa tüm ürünlerde geçerli olur.",
                "conditions": "Koşullar sağlandığında kampanya sepete otomatik uygulanır (kod gerekmez).",
                "priority": "Küçük değer = yüksek öncelik."
            },
            "cols": {
                "name": "Ad",
                "type": "Tür",
                "benefit": "Fayda",
                "condition": "Koşul",
                "priority": "Öncelik"
            },
            "filter": {
                "name": "Kampanya Adı",
                "type": "Tür"
            },
            "benefit": {
                "freeShipping": "Kargo Bedava",
                "buyXPayY": "{buy} Al {pay} Öde"
            },
            "units": {
                "piece": "adet"
            }
        },
        "couponCodesPage": {
            "productSectionTitle": "Hangi Ürünlerde Kullanılabilir",
            "userSectionTitle": "Hangi Kullanıcılar Kullanabilir",
            "include": "Dahil",
            "exclude": "Hariç",
            "includeHint": "Yalnızca seçilenlerde geçerli",
            "excludeHint": "Seçilenler hariç her yerde geçerli",
            "productSearchPlaceholder": "Ürün adı ile ara…",
            "categorySelectPlaceholder": "Kategori seçin",
            "brandSelectPlaceholder": "Marka seçin",
            "tagSelectPlaceholder": "Etiket seçin",
            "customerSearchPlaceholder": "Müşteri adı ile ara…",
            "userLabelSelectPlaceholder": "Kullanıcı etiketi seçin",
            "exportFileName": "kuponlar.xlsx",
            "productMode": {
                "all": "Tümü",
                "products": "Ürünler",
                "categories": "Kategori",
                "brands": "Marka",
                "tags": "Etiket"
            },
            "userMode": {
                "all": "Herkes",
                "users": "Seçili Müşteriler",
                "labels": "Etikete Göre"
            }
        },
        "draftsPage": {
            "newDraft": "Yeni Taslak",
            "customerRequiredBadge": "Müşteri gerekli",
            "itemsCount": "{count} kalem",
            "convertTooltip": "Siparişe çevir",
            "convertBtn": "Siparişe Çevir",
            "editTooltip": "Düzenle",
            "drawerTitle": "Taslak Detayı",
            "customerLabel": "Müşteri",
            "notSelected": "Seçilmedi",
            "productsWithCount": "Ürünler ({count})",
            "productNo": "Ürün #{id}",
            "pieces": "{count} adet",
            "variant": "varyant",
            "estimatedTotal": "Tahmini Toplam",
            "customerNamePlaceholder": "Müşteri adı",
            "columns": {
                "customer": "Müşteri",
                "items": "Kalem",
                "total": "Tutar",
                "note": "Not",
                "date": "Tarih"
            },
            "errors": {
                "draftCustomerRequired": "Bu taslakta müşteri seçilmemiş. Taslağı düzenleyip müşteri ekleyin, sonra siparişe çevirin.",
                "draftAlreadyConverted": "Bu taslak zaten siparişe çevrilmiş.",
                "recordNotFound": "Taslak bulunamadı.",
                "usageDateRange": "Kullanım bitiş tarihi başlangıç tarihinden önce olamaz.",
                "cartEmpty": "Taslakta ürün yok.",
                "convertFailedWithMsg": "Siparişe çevrilemedi: {msg}",
                "convertFailedGeneric": "Siparişe çevrilirken bir hata oluştu."
            },
            "customerMissingMessage": "Bu taslakta müşteri seçilmemiş. Siparişe çevirmek için önce bir müşteri eklemelisiniz. Taslağı şimdi düzenlemek ister misiniz?",
            "customerMissingHeader": "Müşteri Gerekli",
            "cancel": "Vazgeç",
            "convertConfirmMessage": "\"{name}\" taslağını gerçek siparişe çevirmek istediğinize emin misiniz? Stok bu aşamada rezerve edilir.",
            "orderCreated": "Sipariş oluşturuldu #{id}"
        },
        "abandonedCartsPage": {
            "guest": "Misafir",
            "unregisteredSession": "Kayıtsız / oturum",
            "productsWord": "ürün",
            "itemsWord": "adet",
            "recoverable": "Kurtarılabilir",
            "recoverability": "Kurtarılabilirlik",
            "detail": "Detay",
            "goToCustomer": "Müşteriye git",
            "goToCustomerBtn": "Müşteriye Git",
            "cartDetail": "Sepet Detayı",
            "customer": "Müşteri",
            "cartProducts": "Sepetteki Ürünler",
            "cartTotal": "Sepet Toplamı",
            "abandonedAgo": "{duration} önce terk edildi",
            "searchPlaceholder": "Ad / e-posta",
            "abandonStage": "Terk aşaması",
            "lastActivity": "Son aktivite",
            "column": {
                "customer": "Müşteri",
                "products": "Ürünler",
                "amount": "Tutar",
                "abandonDuration": "Terk Süresi"
            },
            "duration": {
                "justNow": "az önce",
                "minutes": "dakika",
                "hour": "saat",
                "minShort": "dk",
                "day": "gün"
            },
            "stage": {
                "active": "Aktif",
                "stage1": "1 saat+",
                "stage2": "1 gün+",
                "stage3": "3 gün+ · son fırsat",
                "lost": "7 gün+ · kayıp"
            },
            "filterStage": {
                "active": "Aktif (<1 saat)",
                "stage1": "1 saat+ (ilk hatırlatma)",
                "stage2": "1 gün+ (ikinci hatırlatma)",
                "stage3": "3 gün+ (son fırsat)",
                "lost": "7 gün+ (kayıp)"
            }
        },
        "barcodePage": {
            "print": "Yazdır",
            "addProduct": "Ürün Ekle",
            "searchPlaceholder": "En az 2 harf yazın...",
            "variantHint": "Varyantlı ürünler kombinasyon başına ayrı etikete açılır.",
            "labelSettings": "Etiket Ayarları",
            "labelsPerRow": "Satır başına etiket",
            "showName": "Ürün adını göster",
            "showPrice": "Fiyatı göster",
            "showSku": "SKU göster",
            "labels": "Etiketler",
            "clearAll": "Tümünü temizle",
            "bulkQty": "Toplu adet:",
            "applyToAll": "Tümüne uygula",
            "incEach": "Her etikete +1",
            "decEach": "Her etiketten -1",
            "toAll": "Hepsine",
            "totalPrefix": "Toplam",
            "labelWord": "etiket",
            "colProduct": "Ürün",
            "colBarcode": "Barkod",
            "colQuantity": "Adet",
            "emptyTitle": "Henüz etiket eklenmedi",
            "emptyText": "Yazdırmak için soldaki panelden ürün arayıp ekleyin. Varyantlı ürünler her kombinasyon için ayrı etikete açılır.",
            "preview": "Önizleme",
            "popupBlocked": "Yazdırma penceresi açılamadı (pop-up engeli olabilir).",
            "printTitle": "Barkod Etiketleri"
        },
        "campaignOffersPage": {
            "drawer": {
                "editTitle": "Teklifleri Düzenle",
                "addTitle": "Kampanya Teklifi Ekle"
            },
            "form": {
                "productLabel": "Ürün",
                "productSearchPlaceholder": "Ürün adı ile ara…",
                "productHint": "Bu ürünün detay sayfasında gösterilecek öneriler.",
                "crossSellTitle": "Çapraz Satış (Tamamlayıcı Ürünler)",
                "crossSellHint": "\"Birlikte alınır\" — bu ürünle birlikte önerilecek tamamlayıcı ürünler.",
                "upSellTitle": "Yukarı Satış (Daha İyi Ürün)",
                "upSellHint": "\"Bunun yerine\" — üst model / daha iyi alternatif önerileri.",
                "productAddPlaceholder": "Ürün ara ve ekle…"
            },
            "columns": {
                "product": "Ürün",
                "crossSell": "Çapraz Satış",
                "upSell": "Yukarı Satış"
            },
            "filters": {
                "productName": "Ürün Adı"
            }
        },
        "priceListSavePage": {
            "title": {
                "edit": "Fiyat Listesini Düzenle",
                "new": "Yeni Fiyat Listesi"
            },
            "subtitle": "B2B fiyat listesi — müşteri grubu/etiketine özel fiyatlandırma",
            "cancel": "Vazgeç",
            "save": "Kaydet",
            "loading": "Yükleniyor...",
            "listInfo": "Liste Bilgileri",
            "listName": "Liste Adı",
            "listNamePlaceholder": "Örn. Toptan Fiyatları",
            "listNameRequired": "Liste adı zorunludur.",
            "generalDiscount": "Genel İndirim (%)",
            "priority": "Öncelik",
            "status": "Durum",
            "active": "Aktif",
            "passive": "Pasif",
            "generalDiscountHint": "Genel indirim, ürüne özel fiyatı olmayan tüm ürünlere uygulanır.",
            "targetAudience": "Hedef Kitle",
            "customerGroups": "Müşteri Grupları",
            "selectGroup": "Grup seç",
            "customerTags": "Müşteri Etiketleri",
            "selectTag": "Etiket seç",
            "targetRequired": "En az bir müşteri grubu veya etiket seçin.",
            "targetHint": "Bu grup <b>veya</b> etikete sahip giriş yapmış müşteriler liste fiyatını görür.",
            "productsAndPrices": "Ürünler & Fiyatlar",
            "fetchByFilterTitle": "Kategori / marka / etiketle ürün çek",
            "fetchProducts": "Ürünleri Getir",
            "fetching": "Getiriliyor",
            "or": "veya",
            "searchSingleProduct": "Tek ürün ara…",
            "all": "Tümü",
            "applyToSelected": "Seçiliye uygula:",
            "percentRatePlaceholder": "% oran",
            "pricePlaceholder": "Fiyat",
            "apply": "Uygula",
            "removeSelected": "Seçilenleri Kaldır",
            "searchProduct": "Ürün ara…",
            "listPrice": "Liste fiyatı:",
            "allProduct": "Tüm ürün",
            "selectVariant": "Varyant seç",
            "noVariant": "— varyantsız",
            "emptyTitle": "Henüz ürün eklenmedi",
            "emptyText": "Yukarıdan kategori, marka veya etiketle ürünleri toplu çekin ya da tek tek arayıp ekleyin. Sonra seçip toplu indirim uygulayabilirsiniz.",
            "breadcrumb": "Fiyat Listesi",
            "edit": "Düzenle",
            "new": "Yeni",
            "filters": {
                "category": "Kategori",
                "brand": "Marka",
                "productTag": "Ürün etiketi"
            },
            "cols": {
                "product": "Ürün",
                "variant": "Varyant",
                "priceDiscount": "Fiyat / İndirim",
                "fixed": "Sabit ₺",
                "percentDiscount": "% İndirim"
            },
            "msg": {
                "alreadyInList": "Bu ürün zaten listede.",
                "productsAdded": "{count} ürün eklendi. Seçili ürünlere toplu indirim uygulayabilirsiniz.",
                "noNewProducts": "Eklenecek yeni ürün bulunamadı (zaten listede veya eşleşme yok).",
                "first500": "İlk 500 ürün getirildi — daha fazlası için filtreyi daraltın.",
                "appliedToProducts": "{count} ürüne uygulandı.",
                "badRows": "{count} ürün satırında eksik/hatalı alan var — ürün ve geçerli fiyat/oran girin."
            }
        },
        "priceListPage": {
            "cols": {
                "list": "Liste",
                "discount": "İndirim",
                "target": "Hedef",
                "specialPrice": "Özel Fiyat",
                "discountSuffix": "indirim",
                "itemsSuffix": "özel fiyat"
            },
            "filters": {
                "listName": "Liste Adı"
            },
            "msg": {
                "targetNotAssigned": "Hedef atanmadı"
            }
        },
        "cartLinksPage": {
            "cols": {
                "title": "Başlık",
                "items": "Ürünler",
                "coupon": "Kupon",
                "stats": "İstatistik",
                "expires": "Son Kullanım"
            },
            "code": "Kod",
            "product": "ürün",
            "viewCount": "Görüntülenme",
            "orderCount": "Sipariş",
            "copyUrl": "URL'yi kopyala",
            "addTitle": "Sepet Linki Oluştur",
            "editTitle": "Sepet Linkini Düzenle",
            "general": "Genel",
            "titlePlaceholder": "Örn. Kampanya sepeti",
            "titleHint": "Müşteriye gösterilmez, yalnızca sizin için.",
            "searchCoupon": "Kupon kodu ara...",
            "noExpiry": "Süresiz",
            "itemsTitle": "Ürünler",
            "addProduct": "Ürün Ekle",
            "noItems": "Henüz ürün eklenmedi",
            "searchProduct": "Ürün ara...",
            "selectVariant": "Varyant seçin",
            "noVariant": "Varyant yok",
            "personalizations": "Kişiselleştirmeler",
            "fileNotSupported": "Dosya alanı burada desteklenmez",
            "requiredFileBlock": "Zorunlu dosya alanı burada doldurulamaz",
            "fillRequiredPers": "Zorunlu kişiselleştirme alanlarını doldurun",
            "urlCopied": "URL panoya kopyalandı",
            "itemError": "Satır {row}: {error}",
            "errors": {
                "personalizationRequired": "Satır {row}: '{name}' kişiselleştirmesi zorunlu",
                "requiredVariant": "Satır {row}: Varyant seçimi zorunlu",
                "invalidVariant": "Satır {row}: Geçersiz varyant",
                "invalidProduct": "Satır {row}: Geçersiz ürün",
                "invalidQuantity": "Satır {row}: Geçersiz adet",
                "invalidPersValue": "Satır {row}: Geçersiz kişiselleştirme değeri",
                "unsupportedPers": "Satır {row}: Ürün için desteklenmeyen kişiselleştirme",
                "persValueTooLong": "Satır {row}: Kişiselleştirme değeri çok uzun",
                "persDependencyNotMet": "Satır {row}: Kişiselleştirme bağımlılığı karşılanmadı"
            }
        },
        "pendingApprovalPage": {
            "cols": {
                "customerGroup": "Müşteri Grubu"
            },
            "filters": {
                "searchPlaceholder": "Ad / e-posta"
            },
            "btn": {
                "approve": "Onayla",
                "reject": "Reddet"
            },
            "confirm": {
                "approveHeader": "B2B Onayı",
                "approveMessage": "\"{name}\" müşterisinin B2B hesabını onaylamak istediğinize emin misiniz?",
                "rejectHeader": "B2B Reddi",
                "rejectMessage": "\"{name}\" müşterisinin B2B başvurusunu reddetmek istediğinize emin misiniz?"
            },
            "msg": {
                "approved": "Müşteri onaylandı (Hesabı Var).",
                "rejected": "Müşteri reddedildi."
            }
        },
        "customerGroupsPage": {
            "editTitle": "Grubu Düzenle",
            "addTitle": "Müşteri Grubu Ekle",
            "groupName": "Grup Adı",
            "namePlaceholder": "Örn. Toptancılar, VIP",
            "assignHint": "Müşterileri gruplara müşteri düzenleme ekranından atayabilirsiniz.",
            "cols": {
                "name": "Grup Adı",
                "members": "Müşteri Sayısı"
            },
            "filters": {
                "name": "Grup Adı"
            }
        },
        "customerListPage": {
            "filters": {
                "searchPlaceholder": "Ad / e-posta",
                "customerGroup": "Müşteri Grubu",
                "b2bStatus": "B2B Durumu"
            },
            "cols": {
                "customerGroup": "Müşteri Grubu",
                "b2b": "B2B"
            },
            "states": {
                "b2bApproved": "Hesabı Var",
                "b2bPending": "Onay Bekliyor",
                "b2bRejected": "Reddedildi",
                "b2bNone": "B2B Değil"
            }
        },
        "appDetailPage": {
            "marketBreadcrumb": "Uygulama Pazarı",
            "statusInstalledActive": "Kurulu · Aktif",
            "statusInstalledInactive": "Kurulu · Pasif",
            "statusNotInstalled": "Kurulu değil",
            "aboutTitle": "Uygulama Hakkında",
            "connectionInfoTitle": "Bağlantı Bilgileri",
            "setupTitle": "Kurulum",
            "loading": "Yükleniyor...",
            "activeLabel": "Aktif",
            "saveSettings": "Ayarları Kaydet",
            "installApp": "Uygulamayı Kur",
            "uninstallApp": "Uygulamayı Kaldır",
            "manageLabel": "Yönetim",
            "credentialsEncrypted": "Girdiğiniz kimlik bilgileri şifrelenerek saklanır.",
            "notFoundTitle": "Uygulama bulunamadı",
            "backToMarket": "Uygulama Pazarına Dön",
            "fieldRequired": "\"{field}\" alanı zorunlu.",
            "settingsSaved": "Ayarlar kaydedildi",
            "appInstalled": "{name} kuruldu",
            "uninstallConfirm": "\"{name}\" uygulamasını kaldırmak istediğinize emin misiniz?",
            "uninstallConfirmButton": "Kaldır",
            "cancel": "Vazgeç",
            "appUninstalled": "Uygulama kaldırıldı"
        }
    },
    "filters": {
        "title": "Filtre Seçenekleri",
        "name": "Ad",
        "user": {
            "id": "Kullanıcı ID"
        },
        "library": {
            "id": "ID (Video ya da Klasör)",
            "title": "Başlık"
        }
    },
    "components": {
        "libraryVideo": {
            "uploadTitle": "Videoları sürükleyin veya tıklayarak seçin"
        },
        "mediaPicker": {
            "remove": "Kaldır",
            "selectFromLibrary": "Kütüphaneden Seç"
        },
        "media": {
            "title": "Medya Kütüphanesi",
            "folders": "Klasörler",
            "newFolder": "Yeni klasör",
            "allFiles": "Tüm Dosyalar",
            "root": "Kök",
            "loading": "Yükleniyor…",
            "searchPlaceholder": "Dosya adına göre ara…",
            "move": "Taşı",
            "uploading": "Yükleniyor…",
            "fileLabel": "dosya",
            "folderLabel": "klasör",
            "fileSingular": "Dosya",
            "rename": "Yeniden adlandır",
            "actions": "İşlemler",
            "noMediaHere": "Bu konumda medya yok.",
            "cancel": "İptal",
            "moveToFolder": "Klasöre Taşı",
            "targetFolder": "Hedef klasör",
            "selectFolder": "Klasör seçin",
            "confirm": "Onay",
            "confirmDeleteFiles": "%s dosya silinsin mi?",
            "confirmDeleteFile": "Bu dosya silinsin mi?",
            "filesDeleted": "%s dosya silindi",
            "fileDeleted": "Dosya silindi",
            "folderName": "Klasör adı",
            "newFolderTitle": "Yeni Klasör",
            "nameRequired": "Ad gerekli",
            "folderCreated": "Klasör oluşturuldu",
            "newName": "Yeni ad",
            "renameFolderTitle": "Klasörü Yeniden Adlandır",
            "updated": "Güncellendi",
            "confirmDeleteFolder": "Bu klasör silinsin mi? İçindeki dosyalar üst klasöre taşınır.",
            "folderDeleted": "Klasör silindi",
            "moved": "Taşındı",
            "moveFailed": "Taşıma başarısız",
            "folderMoved": "Klasör taşındı",
            "folderMoveFailed": "Klasör taşınamadı",
            "filesMoved": "Dosyalar taşındı",
            "fileMoved": "Dosya taşındı",
            "uploadComplete": "Yükleme tamamlandı",
            "uploadFailed": "Yükleme başarısız"
        },
        "iconPicker": {
            "choose": "İkon seç",
            "clear": "Temizle",
            "search": "İkon ara…",
            "noResult": "İkon bulunamadı"
        },
        "themeSchema": {
            "remove": "Kaldır",
            "item": "Öğe",
            "noItems": "Henüz öğe yok.",
            "htmlPlaceholder": "HTML içerebilir",
            "unknownType": "Bilinmeyen tip:",
            "labels": {
                "title": "Başlık",
                "subtitle": "Alt Başlık",
                "shortTitle": "Kısa Başlık",
                "description": "Açıklama",
                "content": "İçerik",
                "poster": "Görsel",
                "image": "Görsel",
                "icon": "İkon",
                "name": "Ad",
                "slug": "Slug",
                "url": "Bağlantı",
                "link": "Bağlantı",
                "items": "Öğeler",
                "text": "Metin",
                "label": "Etiket",
                "value": "Değer",
                "group": "Grup",
                "showSearch": "Arama İkonu",
                "showFavorites": "Favori İkonu",
                "showAccount": "Hesap İkonu",
                "showCart": "Sepet İkonu",
                "showCurrency": "Para Birimi Seçici",
                "showLanguage": "Dil Seçici",
                "variant": "Görünüm Çeşidi",
                "sidebar": "Kenar Çubuğu",
                "button_text": "Buton Metni",
                "button_url": "Buton Bağlantısı",
                "link_text": "Bağlantı Metni",
                "empty_text": "Boş Durum Metni",
                "bg_color": "Arka Plan Rengi",
                "text_color": "Metin Rengi",
                "dismissible": "Kapatılabilir",
                "free_shipping_text": "Ücretsiz Kargo Metni",
                "reviews": "Yorumlar",
                "reviews_variant": "Yorumlar Görünümü",
                "category_ids": "Kategoriler",
                "limit": "Adet Sınırı",
                "fallback_title": "Yedek Başlık",
                "fallback_text": "Yedek Metin",
                "fallback_button_text": "Yedek Buton Metni",
                "socials": "Sosyal Bağlantılar",
                "rate": "Puan",
                "message": "Mesaj"
            }
        },
        "menuTree": {
            "dragToSort": "Sıralamak / taşımak için sürükleyin",
            "addChild": "Alt öğe ekle",
            "dropHere": "Alt öğeleri buraya sürükleyin",
            "columns": "kolon",
            "collapse": "Alt öğeleri gizle",
            "expand": "Alt öğeleri göster"
        },
        "productAddons": {
            "title": "Eklentiler",
            "description": "Bu ürünle birlikte satın alınabilecek ek ürünleri tanımlayın.",
            "addAddon": "Eklenti Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra eklentileri buradan ekleyebilirsiniz.",
            "noAddons": "Henüz eklenti yok",
            "cols": {
                "product": "Ürün",
                "quantity": "Adet",
                "price": "Fiyat",
                "cart": "Sepet"
            },
            "variant": "Varyant",
            "selectVariant": "Varyant kombinasyonu seçin",
            "variantHint": "Eklenti üründe birden fazla varyant varsa hangisinin ekleneceğini seçin.",
            "automatic": "Otomatik",
            "locked": "Kilitli",
            "editAddon": "Eklentiyi Düzenle",
            "newAddon": "Yeni Eklenti",
            "drawerSubtitle": "Ürünle birlikte satılacak ek ürün",
            "cartBehavior": "Sepet Davranışı",
            "autoAddCart": "Sepete otomatik ekle",
            "autoAddCartHint": "Ürün sepete eklenince bu eklenti de eklensin.",
            "cannotRemoveCart": "Sepetten çıkarılamasın",
            "cannotRemoveCartHint": "Müşteri bu eklentiyi sepetten kaldıramaz.",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discount": "İndirim",
            "invoice": "Fatura",
            "cancel": "İptal"
        },
        "productPersonalizations": {
            "title": "Kişiselleştirme Alanları",
            "description": "Müşterinin ürünü kişiselleştirmesi için alanlar tanımlayın (hediye paketi, not, renk seçimi…).",
            "addField": "Alan Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra kişiselleştirme alanlarını buradan ekleyebilirsiniz.",
            "noFields": "Henüz kişiselleştirme alanı yok",
            "editField": "Alanı Düzenle",
            "newField": "Yeni Alan",
            "drawerSubtitle": "Ürün detayında müşteriye gösterilecek alan",
            "cols": {
                "field": "Alan",
                "type": "Tip",
                "price": "Fiyat",
                "rules": "Kurallar"
            },
            "fieldTitle": "Başlık",
            "fieldTitlePlaceholder": "Hediye Paketi",
            "fieldDescription": "Açıklama",
            "fieldDescriptionPlaceholder": "Ürününüz hediye paketiyle gönderilir",
            "types": {
                "boolean": "Evet / Hayır",
                "select": "Seçim",
                "color": "Renk",
                "date": "Tarih",
                "file": "Dosya",
                "text": "Yazı",
                "textarea": "Paragraf"
            },
            "typeHints": {
                "boolean": "Müşteri aç/kapat anahtarıyla seçer.",
                "select": "Müşteri açılır listeden tek seçenek seçer.",
                "color": "Müşteri renk seçeneklerinden birini seçer (varyantlardaki görünüm).",
                "date": "Müşteri tarih seçer.",
                "file": "Müşteri dosya yükler.",
                "text": "Müşteri kısa yazı girer (256 karakter).",
                "textarea": "Müşteri uzun yazı girer (2000 karakter)."
            },
            "items": "Seçenekler",
            "addItem": "Seçenek Ekle",
            "noItems": "Henüz seçenek eklenmedi.",
            "itemLabel": "Etiket",
            "itemValue": "Değer",
            "itemsRequired": "Seçim ve renk tipleri için en az bir seçenek girin.",
            "requiredLabel": "Zorunlu olsun",
            "requiredHint": "Müşteri bu alanı doldurmadan ürünü sepete ekleyemez.",
            "required": "Zorunlu",
            "dependsOn": "Bağımlılık",
            "dependsOnHint": "Seçilen alan doldurulmadan bu alan müşteriye gösterilmez.",
            "noDependency": "Bağımsız (her zaman görünür)",
            "sort": "Sıra",
            "free": "Ücretsiz",
            "noPrices": "Fiyat eklenmedi — alan ücretsiz olur."
        },
        "productAttributeValues": {
            "title": "Özel Alanlar",
            "description": "Ürünün özellik setine tanımlı alan değerlerini girin.",
            "set": "Set",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra özel alan değerlerini buradan girebilirsiniz.",
            "noFields": "Tanımlı özel alan yok",
            "noFieldsHint": "Bu ürüne bir özellik seti atanmadığı için gösterilecek alan yok. Setler kategori üzerinden atanır.",
            "saveValues": "Değerleri Kaydet",
            "invalidJson": "{name} alanı geçerli bir JSON içermiyor."
        },
        "productGallery": {
            "title": "Görsel Galerisi",
            "description": "Kütüphaneden çoklu görsel seçin; sürükleyerek sıralayın, posteri belirleyin.",
            "addImage": "Görsel Ekle",
            "adding": "Ekleniyor",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra görsel galerisini buradan yönetebilirsiniz.",
            "noImages": "Henüz görsel yok",
            "noImagesHint": "Kütüphaneden çoklu görsel seçip sürükleyerek sıralayabilirsiniz.",
            "selectFromLibrary": "Kütüphaneden Seç",
            "dragToSort": "Sürükleyerek sırala",
            "poster": "Poster",
            "makePoster": "Poster yap",
            "makePassive": "Pasif yap",
            "makeActive": "Aktif yap",
            "imagesAdded": "%s görsel eklendi"
        },
        "productPackageItems": {
            "title": "Paket Öğeleri",
            "description": "Bu paketin içereceği ürünleri, adet ve fiyatlarıyla yönetin.",
            "addItem": "Öğe Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra paket öğelerini buradan ekleyebilirsiniz.",
            "noItems": "Henüz paket öğesi yok",
            "noItemsHint": "Bu paketin içereceği ürünleri adet ve fiyatlarıyla ekleyin.",
            "cols": {
                "product": "Ürün",
                "quantity": "Adet",
                "price": "Fiyat",
                "usage": "Kullanım"
            },
            "variant": "Varyant",
            "selectVariant": "Varyant kombinasyonu seçin",
            "variantHint": "Paket öğesi üründe birden fazla varyant varsa hangisinin dahil edileceğini seçin.",
            "editItem": "Paket Öğesini Düzenle",
            "newItem": "Yeni Paket Öğesi",
            "drawerSubtitle": "Pakete dahil edilecek ürün",
            "usageRule": "Kullanım Kuralı",
            "fixedDate": "Sabit Tarih",
            "dayCount": "Gün Sayısı",
            "usageDayCount": "Kullanım Gün Sayısı",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discounted": "İndirimli",
            "cancel": "İptal",
            "days": "gün"
        },
        "productVariants": {
            "title": "Varyantlar",
            "description": "Renk, beden vb. kombinasyonları, her biri için stok ve fiyat ile yönetin.",
            "stockReadonlyHint": "Varyant stoğu salt-okunurdur; yalnızca Stok Yönetimi (satın alma / düzeltme / transfer / sayım) üzerinden değişir.",
            "addCombination": "Kombinasyon Ekle",
            "saveProductFirst": "Önce ürünü kaydedin",
            "saveProductFirstHint": "Ürün oluşturulduktan sonra varyant kombinasyonlarını buradan ekleyebilirsiniz.",
            "noVariants": "Henüz varyant yok",
            "noVariantsHint": "Renk, beden vb. kombinasyonları stok ve fiyatlarıyla ekleyin.",
            "cols": {
                "combination": "Kombinasyon",
                "image": "Görsel",
                "stock": "Stok",
                "price": "Fiyat"
            },
            "selectedCount": "{count} kombinasyon seçildi",
            "deleteSelected": "Seçilenleri Sil",
            "deleteSelectedConfirm": "Seçili {count} kombinasyon silinecek. Onaylıyor musunuz?",
            "bulkCurrency": "Para birimi",
            "bulkApply": "Uygula & Kaydet",
            "listSeparately": "Varyantları ayrı listele",
            "listSeparatelyHint": "Açıksa her varyant kombinasyonu ürün listesinde ayrı bir ürün gibi gösterilir.",
            "listVariantGroup": "Listeleme varyant grubu",
            "listVariantGroupHint": "Liste sayfasında bu gruba göre ayrı kart gösterilir (örn. Renk). Diğer boyutlar ürün sayfasında seçilir.",
            "autoFirstGroup": "Otomatik (ilk grup)",
            "addImage": "Görsel Ekle",
            "manageImages": "Görselleri Yönet",
            "imageDrawerSubtitle": "Sürükleyerek sırala, ekle veya kaldır",
            "noImages": "Henüz görsel yok — kütüphaneden ekleyin.",
            "dragToSort": "Sıralamak için sürükleyin",
            "inlineHint": "Stok ve fiyatı tablodan; görselleri ise görsel kutucuğuna tıklayıp açılan pencereden düzenleyin.",
            "generateTitle": "Kombinasyon Üret",
            "generateSubtitle": "Değerleri seç, tüm kombinasyonlar otomatik oluşturulsun",
            "generateHint": "Seçilen değerlerin tüm kombinasyonları boş olarak (stok 0, fiyatsız) oluşturulur. Zaten var olanlar atlanır; stok ve fiyatı sonra tablodan girebilirsiniz.",
            "comboPreview": "{count} kombinasyon oluşturulacak",
            "generateResult": "{created} kombinasyon oluşturuldu, {skipped} tanesi zaten vardı (atlandı).",
            "generate": "Üret",
            "variantSelection": "Varyant Seçimi",
            "noVariantTypes": "Bu ürün grubunda tanımlı varyant tipi yok.",
            "prices": "Fiyatlar",
            "addPrice": "Fiyat Ekle",
            "noPrices": "Fiyat eklenmedi — ana ürün fiyatı geçerli olur.",
            "discounted": "İndirimli",
            "cancel": "İptal"
        }
    },
    "customTable": {
        "noData": "Listelenecek veri bulunamadı.",
        "showingPageInformationPattern": "%s kayıttan, %d ile %d arası gösteriliyor"
    },
    "userMenu": {
        "language": "Dil",
        "account": "Hesabım",
        "security": "Güvenlik",
        "userRoles": "Üyeler & Roler",
        "integration": "Entegrasyonlar",
        "darkMode": "Koyu Mod",
        "signOut": "Çıkış Yap"
    },
    "footer": {
        "copyrightText": "Ticatix E-Ticaret Çözümleri. Tüm hakları saklıdır."
    },
    "endpointActions": {
        "get": "Görüntüleme",
        "post": "Ekleme",
        "put": "Güncelleme",
        "delete": "Silme"
    },
    "responseErrors": {
        "record_not_found": "Kayıt bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen farklı bir kayıt arayınız.",
        "method_not_found": "İşlem bulunamadı. Silinmiş veya başka bir yere taşınmış olabilir. Lütfen tekrar deneyin.",
        "invalid_file_type": "Geçersiz dosya türü seçildi. Lütfen uygun bir dosya türü kullanınız.",
        "current_password_invalid": "Mevcut şifre hatalı. Lütfen doğru şifreyi girip tekrar deneyiniz.",
        "this_group_not_usable": "Bu grup şu an kullanılamaz. Lütfen farklı bir grup seçin.",
        "invalid_identification_number": "Geçersiz kimlik numarası girildi. Lütfen geçerli bir kimlik numarası kullanınız.",
        "validate_error": "Doğrulama hatası oluştu. Lütfen bilgilerinizi kontrol ederek tekrar deneyiniz.",
        "provider_handler_not_found_by_code": "Belirtilen koda göre sağlayıcı bulunamadı. Lütfen geçerli bir kod giriniz.",
        "video_id_invalid": "Geçersiz video kimliği girdiniz. Lütfen geçerli bir kimlik giriniz.",
        "invalid_customer_id": "Müşteri numarası hatalı. Lütfen geçerli bir müşteri numarası ile tekrar deneyiniz.",
        "login_description": "Lütfen tarafınıza iletilen yetkili giriş bilgilerini kullanarak oturum açın.",
        "login_error": "Giriş bilgilerinizi kontrol edin.",
        "invalid_credentials": "E-Posta veya Şifre hatalı. Lütfen geçerli kimlik bilgileri ile tekrar deneyiniz."
    },
    "topbar": {
        "search": "Ara...",
        "notifications": "Bildirimler",
        "appsInstalled": "{n} kurulu",
        "appsEmpty": "Henüz kurulu uygulama yok",
        "loading": "Yükleniyor...",
        "market": "Pazar",
        "searchHint": "Ürün veya müşteri arayın…",
        "searchEmpty": "Sonuç bulunamadı",
        "searchMin": "Aramak için en az 2 karakter girin",
        "products": "Ürünler",
        "customers": "Müşteriler",
        "orders": "Siparişler",
        "categories": "Kategoriler",
        "brands": "Markalar",
        "coupons": "Kuponlar",
        "variantGroups": "Varyant Tipleri",
        "productGroups": "Ürün Grupları",
        "suppliers": "Tedarikçiler",
        "units": "Birimler",
        "attributeSets": "Özellik Setleri",
        "tags": "Etiketler",
        "customerGroups": "Müşteri Grupları",
        "discountCampaigns": "İndirim Kampanyaları",
        "marketingCampaigns": "Pazarlama Kampanyaları",
        "automations": "Otomasyonlar",
        "priceLists": "Fiyat Listeleri",
        "salesChannels": "Satış Kanalları",
        "warehouses": "Depolar",
        "menus": "Menüler",
        "pages": "Sayfalar",
        "notifEmpty": "Henüz bildirim yok",
        "notifMarkAll": "Tümünü okundu işaretle",
        "notifNew": "yeni",
        "notifAll": "Tümü",
        "notifUnread": "Okunmayan",
        "notifRead": "Okunan",
        "notifClearAll": "Tümünü temizle",
        "notifDelete": "Sil",
        "notifSwipeHint": "Silmek için sağa kaydır",
        "notifClearConfirm": "Tüm bildirimler silinsin mi?",
        "notifClearYes": "Evet, sil",
        "notifMarkAllShort": "Tümü okundu"
    }
};
